/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-empty-function */
import React, { useState, createContext, useEffect, useReducer, useMemo, useRef, useCallback } from 'react';
import Axios from 'axios';
import dynamic from 'next/dynamic';
import {
  ComponentProps,
  DataUpdateProperties,
  SearchResultAlertType,
  TooltipContentProps,
  TooltipLayerHandle,
} from '../index.types';
import {
  StyledSearchResultContainerDiv,
  StyledFilterContainerDiv,
  StyledSearchResultPropertyContainer,
  StyledAlertNotificationDiv,
} from '../index.styles';
import { eventUtil } from '@marriott/mi-ui-library-shop';
import { InitialSearchResult, UpdateSearchResult, UpdateSearchState } from '../store/store.reducer';
import {
  getInitialSearchMockState,
  getSearchResultQuery,
  SearchActions,
  getSearchFilterClearState,
  getSearchAppliedFilter,
  getShopQueryForSearchInput,
} from '../store/store.action';
import SM from '../lib/config';
import { SearchResultAlertContext, SearchFilterContext, SearchResultContext } from '../index.context';
import { PaginationSortByComponent } from '../../../molecules/paginationSortBy';
import CommonUtils from '../lib/CommonUtils';
import {
  clearAllFilterKey,
  DEFAULT_SORT_OPTS,
  DefaultValue,
  maxCapacityKey,
  noAvailabilityKey,
  noHotelsWithinRadiusKey,
  noNearAddressKey,
  propertyCardHiddenAlertCodes,
  RECOMMENDED_OPTION,
  SearchFacetsConstants,
  SearchFacetsList,
  searchFilters,
  SearchPageAlerts,
  SearchSortFieldForDISTANCE,
  SearchSortFieldsDirection,
  tooManyPropertiesErrorKey,
  unsuccessfulSellKey,
  AMPAlertPriority,
  SERPAlertPriority,
  tooltipAmenities,
  SEARCH_FALLBACK_SERVER_ERRORS,
  LinkMatchRegex,
  ErrorFrameworkCodeArray,
  UXL_COMPLETE_FAIL,
} from '../index.constant';
import {
  getCurrentPriceRateBlock,
  getCurrRateAmountBlock,
  enableBoostBrands,
  callDataLayerOnFeatureChanges,
  geoCodeAddress,
  getShopTntId,
  executeUXLQueries,
  callDataLayerForSearchFallback,
  isServerError,
} from '../lib/helper';
import { SkeletonPropertyCardLoaderComponent } from '../../../molecules/skeletonPropertyCardLoader';
import { getESTDate, Messages } from '@marriott/mi-ui-library';
import clsx from 'clsx';
import {
  getAlertsData,
  getTotalFilterCount,
  updateDataLayerObj,
  updateDataLayerObjSigin,
  extractDataFromResponse,
  extractDataFromDTTResponse,
  getAllPropertyIDS,
  updateSessionDocProperties,
  interactionsAppliedOnSERP,
  fieldsInteractedInSERP,
  isUnsuccessfulUserJourney,
  enableHotelList,
  updateQueryParams,
} from '../lib/helper';
import moment from 'moment';
import { useApolloClient, useMutation } from '@apollo/client';
import { useCheckBreakpoint } from '../../../hooks';
import { phoenixShopUpdateCustomerSavedProperties } from '@marriott/mi-shop-graphql';
import { usePageContext } from '../../../context/PageContext/index';
import { getShopResult } from '../lib/shop.api';
import { getDTTShopResult } from '../lib/shop.dtt.api';
import { inspect } from 'util';
import {
  dttRatesTransformer,
  getBonvoyMemberLevel,
  getDeviceType,
  getLoggerApiURL,
  getMockSearchResultData,
  getRecipeId,
  getSearchDestinationType,
  getSearchDestinationTypeAnalytics,
  getSooModel,
  getWeekType,
  isRecommendedSortSegmentId,
  logger,
  updateSessionDocErrorMessages,
  usePageContextStore,
} from '../../../utils';
import { useSessionUpdateContext } from '../../../context/SessionUpdateContext'; // 'libs/mi-shop-components/src/context';
import { useHQVContext } from '../../../context';
import { HQV_ACTIONS } from '../../../reducers';
import { isLocalDev } from '@marriott/mi-apollo-client-utils';
import { hardCodedAllLocale, validErrorCodes, validWarningCodes } from '../index.constant';
import { useClientEnvVarsStore } from '@marriott/mi-store-utils';
import { targetPayloadRequest } from '@marriott/mi-headless-utils';
import {
  convertArabicToEnglishNumbers,
  convertHindiToEnglishNumbers,
} from '../../../lib/organisms/SearchForm/utils/DateUtils';
import {
  propertyCardHiddenCodes,
  REWARDS_REDEMPTION_CLUSTER_CODES_HQV,
  TARGET_SEGMENT_API_ENDPOINT,
  TARGET_SEGMENT_API_ENDPOINT_V1,
} from '../../../constants/lib/constants';
import { useSearchResultsStore } from '../../../modules/store/searchResultsStore';
import { RATES_DATA } from '../../../modules/constants';
import { checkIfSOOEnabled, determineExclusionCriteriaForSortOptions, isFlexibleDate } from '../../../modules/utils';

import PropertyListComponent from '../../../molecules/propertyList';
import { SearchResultsTooltipLayer } from '../SearchResultsTooltipLayer';
const FiltersComponent = dynamic(() =>
  import('../../../molecules/filtersComponent').then(module => module.FiltersComponent)
);
const MemberExclusiveBanner = dynamic(() =>
  import('../../../molecules/memberExclusiveBanner').then(module => module.MemberExclusiveBanner)
);
const AlertNotification = dynamic(() =>
  import('../../../molecules/alerts/AlertNotification').then(module => module.AlertNotification)
);

const { log } = logger({})('SearchResults/searchResultsMainComponent');
declare module 'react' {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  interface HTMLAttributes<T> {
    custom_click_track_value?: string;
  }
}

declare global {
  interface Window {
    dataLayer?: Record<string, unknown>;
    adobe?: {
      target?: {
        getOffers: any;
      };
    };
  }
}

export const renderedData = createContext({
  jsonContent: {},
  configData: SM,
  isMapViewEnabled: false,
  setISMapViewEnabled: () => {},

  GOOGLE_MAP_API_KEY: '',

  recentlyViewed: [],
  setRecentlyViewed: () => {},

  featureSelected: false,
  setFeatureSelected: () => {},

  isFlexibleDateSearch: false,
  setIsFlexibleDateSearch: () => {},

  isSearchClicked: false,
  setIsSearchClicked: () => {},

  isStateOrCountry: false,
  setIsStateOrCountry: () => {},

  continueCtaProperty: '',
  setContinueCtaProperty: () => {},

  sessionObject: { consumerID: '', accessToken: '', sessionID: '' },
  setSessionObject: () => {},

  revisionToken: '',
  setRevisionToken: (obj: object) => obj,

  savedProperties: [],
  setSavedProperties: (_savedProperties: string[]) => {},

  formValues: {},
  setFormValues: (_formValues: any) => {},

  isSpecialRateSearch: false,
  setIsSpecialRateSearch: () => {},

  isAutoSuggestSelectedSearch: false,
  setIsAutoSuggestSelectedSearch: (_value: boolean) => {},

  isRecentViewSelectedSearch: false,
  setIsRecentViewSelectedSearch: (_value: boolean) => {},

  isErrorState: true,
  setIsErrorState: () => {},

  isLastCardProcessed: false,
  setIsLastCardProcessed: () => {},

  imageURL: '',
  setImageURL: () => {},

  isTaxesandFeesIncludedFromPopup: false,
  setIsTaxesandFeesIncludedFromPopup: (_value: boolean) => {},
});

export const SavedPropertiesDispatchContext = createContext<any>({});

const SearchResultComp: React.FC<ComponentProps> = ({
  jsonContent,
  GOOGLE_MAP_API_KEY,
  requestID = '',
  searchQueryData,
  completeSession,
  AiSearchResults,
  onOpenHotelPanel,
}) => {
  const {
    pageState,
    requestId,
    resolvedUrl,
    headersData,
    isDTT,
    query,
    currentLocale,
    SESSION_APP_GET_CALL_URL,
    SESSION_GET_CALL_URL_CLIENT,
    datalayerParams,
    datalayerProperties,
    sessionData,
    setSessionData,
    isAuthorMode,
    featureFlagSOO,
    pageVal,
  } = usePageContext();

  const isSOOEnabled = checkIfSOOEnabled(featureFlagSOO);

  const updatePageContextVar = usePageContextStore(state => state.updatePageContextVar);

  const skipQuery = useMemo(() => {
    return !!pageState?.authorModee || !!isAuthorMode;
  }, [pageState, isAuthorMode]);

  const google_map_api_key = GOOGLE_MAP_API_KEY
    ? GOOGLE_MAP_API_KEY
    : useClientEnvVarsStore.getState().envVarsObject['GOOGLE_MAP_API_KEY'];
  const NEXT_PUBLIC_PREFIX =
    process.env['NEXT_PUBLIC_PREFIX'] || useClientEnvVarsStore.getState().envVarsObject['NEXT_PUBLIC_PREFIX'];
  const loggerApiURL = getLoggerApiURL(NEXT_PUBLIC_PREFIX, headersData?.serpv1 === 'true');
  const { interactionsSelected, setInteractionsSelected } = useSessionUpdateContext();
  const [popPupOpen, setPopupOpen] = useState<boolean>(false);
  const [updateSearchCounter, setUpdateSearchCounter] = useState<number>(0);
  const [hidePropertyList, setHidePropertyList] = useState<boolean>(true);
  /**
   * When the page is loaded with view=map, we want to avoid briefly rendering the
   * list view with results between "results fetched" and "map view enabled".
   * This flag keeps the list hidden until we explicitly turn on map view after
   * the initial search completes.
   */
  const [suppressListUntilMapReady, setSuppressListUntilMapReady] = useState<boolean>(() => {
    if (typeof window === 'undefined') {
      return false;
    }
    try {
      const params = new URLSearchParams(window.location.search);
      return params.get(searchFilters.view) === 'map';
    } catch {
      return false;
    }
  });
  const [segmentId, setSegmentId] = useState('');
  const [isSavedDataStaleError, setIsSavedDataStaleError] = useState<boolean>(false);
  const [searchDestinationTypeForSession, setSearchDestinationTypeForSession] = useState<string>('');
  let searchDestinationTypeForDatalayer = '';
  const setSearchResultsState = useSearchResultsStore(
    (state: { setSearchResultsState: any }) => state.setSearchResultsState
  );

  const deviceType = getDeviceType();
  const weekType = getWeekType(completeSession?.data?.AriesSearch?.search_is_weekend_stay);
  const searchDestinationType = getSearchDestinationType(
    completeSession?.data?.AriesSearch?.searchCriteria?.address?.destinationType ?? ''
  );
  const rewardsLevel = getBonvoyMemberLevel(
    completeSession?.data?.AriesCommon?.memState,
    completeSession?.data?.memberLevel,
    completeSession?.data?.AriesCommon?.mr_prof_member_level_abbr
  );
  const searchCity = completeSession?.data?.AriesSearch?.searchCriteria?.address?.city ?? '';
  const searchState = completeSession?.data?.AriesSearch?.searchCriteria?.address?.stateProvince ?? '';
  const searchCountry = completeSession?.data?.AriesSearch?.searchCriteria?.address?.country ?? '';
  const sooModel: string = getSooModel(segmentId);

  const sooOptions = {
    ...(weekType && { weekType: weekType }),
    ...(rewardsLevel && { rewardsLevel: rewardsLevel }),
    ...(searchCity && { searchCity: searchCity }),
    ...(searchState && { searchState: searchState }),
    ...(searchCountry && { searchCountry: searchCountry }),
    deviceType: deviceType,
    searchDestinationType: searchDestinationType,
    sooModel: sooModel,
  };

  if (requestId) {
    requestID = requestId;
  }
  const configData = SM; //load config from config file

  const apolloClientRef = useApolloClient(); // create apollo client instance
  const { getMedia, getCurrencyConversionRate, getCustomerToken, getFlexibleFilter, getDatedFilter } = isDTT
    ? getDTTShopResult(apolloClientRef)
    : getShopResult(apolloClientRef); // import all the api function

  const [isInitialLoad, setInitialLoad] = useState(true);

  const [updatedDestinationType, setUpdatedDestinationType] = useState('');
  const handleNextClick = (isInitialLoadData: boolean): void => {
    setInitialLoad(isInitialLoadData);
  };
  const queryCommonContext = {
    /**
     * define common params for all the query
     */
    context: {
      headers: {
        'x-request-id': requestID !== '' ? requestID : `${Date.now()}`,
        'accept-language': currentLocale,
      },
    },
  };

  const stateSearchFromSession =
    !completeSession?.data?.AriesSearch?.searchCriteria?.address?.latitude &&
    !completeSession?.data?.AriesSearch?.searchCriteria?.address?.city &&
    (completeSession?.data?.AriesSearch?.searchCriteria?.address?.stateProvince ||
      completeSession?.data?.AriesSearch?.searchCriteria?.address?.country ||
      completeSession?.data?.AriesSearch?.searchCriteria?.address?.region) &&
    !completeSession?.data?.AriesSearch?.searchCriteria?.address?.city;

  // maintain global state for search result list item
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  // const mockSearchResult: any = SearchResultMockData;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const [searchResult, setSearchResult]: any = useReducer(UpdateSearchResult, InitialSearchResult);

  const { hqvDispatch } = useHQVContext();
  /** check if we are getting view=map from session
   * then isMapViewEnabled = true
   */
  const pageResultViewType = completeSession?.data?.AriesSearch?.searchCriteria?.searchResultViewType
    ? completeSession?.data?.AriesSearch?.searchCriteria?.searchResultViewType === 'map'
    : completeSession?.cacheData?.data?.AriesSearch?.searchCriteria?.searchResultViewType === 'map';

  const clickTrackingLoc = 'Phoenix Search Results';
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const [isMapViewEnabled, setISMapViewEnabled]: any = useState<boolean>(false);
  const [wasMapViewEnabled, setWasMapViewEnabled]: any = useState<boolean>(false);
  const [isDrawerVisible, setIsDrawerVisible] = useState<boolean>(true);

  const [isMobileState, setIsMobile] = useState(CommonUtils.isOnlyMobileView());
  //check loading of current result
  const [isLoadingSearchResult, setIsLoadingSearchResult] = useState<boolean>(true);

  //set search result errors in global state if any
  const [searchResultAlerts, setSearchResultAlerts] = useState<SearchResultAlertType>(SearchPageAlerts.default);

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const [recentlyViewed, setRecentlyViewed]: any = useState<any>([]);

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const [featureSelected, setFeatureSelected]: any = useState<boolean>(false);
  const [distance, setDistance] = useState<number>(
    parseFloat(completeSession?.data?.AriesSearch?.searchCriteria?.searchRadius)
  );
  const [numberOfNights, setNumberOfNights] = useState<number>(
    sessionData?.data
      ? sessionData?.data?.AriesSearch?.searchCriteria?.availabilityRequestVO?.lengthOfStay
      : sessionData?.cacheData?.data?.AriesSearch?.searchCriteria?.availabilityRequestVO?.lengthOfStay
  );

  const SPECIAL_RATE_TYPE_NONE = 'none';
  const [isSpecialRateSearch, setIsSpecialRateSearch]: any = useState<boolean>(false);
  const isFlexibleSearchType =
    pageVal === 'chat'
      ? false
      : (completeSession?.data?.AriesSearch?.searchCriteria?.availabilityRequestVO?.flexibleDate ||
          !completeSession?.data?.AriesSearch?.searchCriteria?.availabilityRequestVO?.checkInDate ||
          searchQueryData?.options?.endDate === searchQueryData?.options?.startDate) &&
        completeSession?.data?.AriesSearch?.searchCriteria?.searchType !== 'Keyword';
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const [isFlexibleDateSearch, setIsFlexibleDateSearch]: any = useState<boolean>(
    pageState?.authorMode || isAuthorMode ? false : isFlexibleSearchType
  );
  const [leisureRegionValue, setLeisureRegionValue] = useState<string>(
    completeSession?.data?.AriesSearch?.searchCriteria?.address?.region
      ? completeSession?.data?.AriesSearch?.searchCriteria?.address?.region
      : ''
  );
  const sessionDataObject = sessionData?.data ? sessionData?.data : sessionData?.cacheData?.data;
  const showFullPriceInSession = sessionDataObject?.AriesSearch?.searchCriteria?.showFullPrice;
  const isFlexibleDateSearchRef = useRef<boolean>(isFlexibleSearchType ? true : false);
  const modalRefElement = useRef<any>();

  const nightsCount = numberOfNights;

  // maintain search query global state with update/get
  const [searchQueryState, setSearchQuery] = useReducer(
    UpdateSearchState,
    getInitialSearchMockState(
      searchQueryData,
      isSOOEnabled,
      currentLocale,
      segmentId,
      stateSearchFromSession,
      sessionDataObject?.AriesSearch?.searchCriteria?.address?.destinationType,
      isFlexibleDateSearch,
      isDTT,
      sooOptions
    )
  );

  const [pointsChecked, setPointsChecked] = useState<boolean>(searchQueryState[SearchFacetsConstants.points]);

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const [isSearchClicked, setIsSearchClicked]: any = useState<boolean>(false);

  const [isFilterChange, setISFilterChange] = useState<boolean>(false);

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const [isErrorState, setIsErrorState]: any = useState<boolean>(true);

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const [imageURL, setImageURL]: any = useState<string>('');

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const [isLastCardProcessed, setIsLastCardProcessed]: any = useState<boolean>(false);

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const [isStateOrCountry, setIsStateOrCountry]: any = useState<boolean>(false);
  const isLargeDesktop = useCheckBreakpoint('viewportXl');
  const isDesktop = useCheckBreakpoint('viewportL');

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const [continueCtaProperty, setContinueCtaProperty]: any = useState(
    completeSession?.data
      ? completeSession?.data?.AriesReservation?.propertyId
      : completeSession?.cacheData?.data?.AriesReservation?.propertyId
  );

  const consumerID = completeSession?.data ? completeSession?.data?.consumerID : null;
  const accessToken = completeSession?.data ? completeSession?.data?.accessToken : null;
  const sessionTokenFromCompleteSession = sessionData?.data?.sessionToken || sessionData?.key;
  const sessionID = completeSession?.data ? sessionTokenFromCompleteSession : null;
  const rewardsID = completeSession?.data ? completeSession?.data?.rewardsId : null;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const [sessionObject, setSessionObject]: any = useState({
    consumerID: consumerID,
    accessToken: accessToken,
    sessionID: sessionID,
    rewardsId: rewardsID,
  });

  //consumerID for LAR queries
  const custNumber = useRef<string>((isDTT ? consumerID : rewardsID) || '');

  const [keywordSearch, setKeywordSearch] = useState(
    completeSession?.data?.AriesSearch?.searchCriteria?.searchType === 'Keyword'
  );

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const [revisionToken, setRevisionToken]: any = useState<any>('');

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const [savedProperties, setSavedProperties]: any = useState<any>([]);

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const [filterUpdateData, setFilterUpdateData] = useState<any>();

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const [formValues, setFormValues] = useState<any>({});
  const [isAutoSuggestSelectedSearch, setIsAutoSuggestSelectedSearch] = useState<boolean>(false);
  const [isRecentViewSelectedSearch, setIsRecentViewSelectedSearch] = useState<boolean>(false);
  //state to detect error scenario
  const [errorScenario, setErrorScenario] = useState<boolean>(false);
  const [isStateSearch, setStateSearch] = useState<boolean>(stateSearchFromSession);
  const [isDestinationSearch, setIsDestinationSearch] = useState<boolean>(false);
  const [hiddenDestData, setHiddenDestData] = useState<any>(
    completeSession?.data?.AriesSearch?.searchCriteria?.address
  );
  const [isTaxesandFeesIncludedFromPopup, setIsTaxesandFeesIncludedFromPopup] = useState<boolean>(false);
  const [fusionSearchId, setFusionSearchId] = useState<string>('');
  const [sessionIdValue, setSessionIdValue] = useState<string>(sessionData?.data?.sessionToken || sessionData?.key);
  const [viewChangeButtonClicked, setViewChangeButtonClicked] = useState<boolean>(false);
  const [fetchCurrencyConversionFactors, setFetchCurrencyConversionFactors] = useState<boolean>(false);
  const [isCorpCodeEntered, setIsCorpCodeEntered] = useState<boolean>(false);
  const [isInitialSearchCall, setIsInitialSearchCall] = useState<boolean>(true);
  const [targetSegmentCallCompleted, setTargetSegmentCallCompleted] = useState<boolean>(false);

  useEffect(() => {
    //Can not remove these selectors, As these selectors are from AEM header component.
    const staticHeaderLogo = document.querySelector('.m-header__thin-logo-icon');
    const staticHeader = document.querySelector('.m-header__thin-container');
    staticHeaderLogo &&
      staticHeaderLogo.addEventListener('click', () => {
        sessionStorage.setItem('map_view', 'false');
      });
    if (staticHeader) {
      staticHeader.setAttribute('style', 'z-index:5');
    }
    const screenWidth = window.innerWidth;
    const searchUrlParams = new URLSearchParams(window.location.search);
    if (!searchUrlParams?.has('deviceType')) {
      searchUrlParams.set('deviceType', screenWidth < 992 ? 'mobile-web' : 'desktop-web');
      window.history.replaceState({}, '', decodeURIComponent(`?${searchUrlParams.toString()}`));
    }
  }, []);

  useEffect(() => {
    if (
      REWARDS_REDEMPTION_CLUSTER_CODES_HQV.includes(
        formValues?.specialRates?.corporateCode?.toLocaleUpperCase() ||
          sessionData?.data?.AriesSearch?.searchCriteria?.availabilityRequestVO?.corporateCode?.toLocaleUpperCase()
      )
    ) {
      setIsCorpCodeEntered(true);
    } else {
      setIsCorpCodeEntered(false);
    }
  }, [formValues?.specialRates?.corporateCode]);

  const callSegmentApi = async () => {
    const sessionDataObject = sessionData?.data ? sessionData?.data : sessionData?.cacheData?.data;
    const segmentPayload = targetPayloadRequest(
      {
        isUxl: 'false',
        mboxName:
          process.env['TARGET_SEGMENT_MBOX_NAME'] ||
          useClientEnvVarsStore.getState().envVarsObject['TARGET_SEGMENT_MBOX_NAME'],
        propertyToken:
          process.env['TARGET_SEGMENT_PROPERTY_TOKEN'] ||
          useClientEnvVarsStore.getState().envVarsObject['TARGET_SEGMENT_PROPERTY_TOKEN'],
      },
      {
        env_site_id: window?.['dataLayer']?.['env_site_id'],
        search_destination_type: sessionDataObject?.AriesSearch?.searchCriteria?.address?.destinationType,
        page_url_query_string: sessionDataObject?.AriesCommon?.page_url_query_string,
        search_destination_lat_long:
          sessionDataObject?.AriesSearch?.searchCriteria?.address?.latitude &&
          sessionDataObject?.AriesSearch?.searchCriteria?.address?.longitude
            ? `${sessionDataObject.AriesSearch.searchCriteria.address.latitude},${sessionDataObject.AriesSearch.searchCriteria.address.longitude}`
            : '',
      }
    );
    segmentPayload.id.tntId = getShopTntId(window?.['dataLayer']);
    const consumerId = sessionData?.cacheData?.data?.consumerID ?? sessionData?.data?.consumerID;
    if (consumerId) {
      segmentPayload.id.thirdPartyId = consumerId;
    }
    try {
      const response = await Axios.post(
        headersData?.serpv1 === 'true' ? TARGET_SEGMENT_API_ENDPOINT_V1 : TARGET_SEGMENT_API_ENDPOINT,
        {
          targetReqPayload: segmentPayload,
        }
      );
      const segmentIdValue = response?.data?.segmentId;
      setSegmentId(response?.data?.segmentId);
      setTargetSegmentCallCompleted(true);
      if (
        isRecommendedSortSegmentId(segmentIdValue) &&
        !isStateSearch &&
        !determineExclusionCriteriaForSortOptions(
          sessionDataObject?.AriesSearch?.searchCriteria?.address?.latitude,
          sessionDataObject?.AriesSearch?.searchCriteria?.address?.destinationType,
          sessionDataObject?.AriesSearch?.searchCriteria?.availabilityRequestVO?.flexibleDate
        )
      ) {
        setSearchQuery({
          type: SearchActions.updateQueryAndOtherSearchQueryParam,
          payload: {
            [SearchFacetsConstants.sort]: {
              fields: [
                {
                  field: RECOMMENDED_OPTION,
                  direction: SearchSortFieldsDirection.desc,
                },
              ],
            },
          },
        });
      }
    } catch (error) {
      setTargetSegmentCallCompleted(true);
      throw error; // Propagate the error up for handling
    }
  };

  useEffect(() => {
    if (sessionObject?.consumerID && sessionObject?.accessToken) {
      consumeRevisionToken();
    }
    if (window && window?.dataLayer) {
      const currentDate = moment();
      const startDate = completeSession?.data?.AriesSearch?.searchCriteria?.availabilityRequestVO?.checkInDate;
      const endDate = completeSession?.data?.AriesSearch?.searchCriteria?.availabilityRequestVO?.checkOutDate;
      const diffFromStartDate = Math.abs(moment.duration(currentDate.diff(startDate)).asDays() ?? 0);
      const diffFromEndDate = Math.abs(moment.duration(currentDate.diff(endDate)).asDays() ?? 0);
      // set availability checkbox true or false basis of search object
      const isIncludeUnAvailableProperties = diffFromStartDate > 6 || diffFromEndDate > 6 ? true : false;
      window.dataLayer['search_show_available_hotels'] = !isIncludeUnAvailableProperties;
    }
  }, []);

  useEffect(() => {
    const searchOject = searchQueryState[SearchFacetsConstants.search];
    if (searchQueryData?.latitude && !searchOject[SearchFacetsConstants.latitude]) {
      searchOject[SearchFacetsConstants.latitude] = searchQueryData?.latitude;
      searchOject[SearchFacetsConstants.longitude] = searchQueryData?.longitude;
      searchOject[SearchFacetsConstants.destination] = undefined;
      setSearchQuery({
        type: SearchActions.updateQueryAndOtherSearchQueryParam,
        payload: {
          [SearchFacetsConstants.search]: searchOject,
        },
      });
    }
  }, [searchQueryData]);

  const displayDefaultError = (e?: any, data?: any) => {
    Axios.post(loggerApiURL, {
      message: `SearchResults component UXL error for sessionId ${sessionID}: ${inspect(e)}`,
    });
    setIsLoadingSearchResult(false);
    // Checking if we should display the stubborn error message
    if (
      (!data || !data.total || data?.total === 0) &&
      !data?.status?.[0]?.errors?.[0]?.code &&
      !data?.status?.[0]?.warnings?.[0]?.code
    ) {
      setSearchResultAlerts(
        getAlertsData(jsonContent?.alertsListArray && jsonContent?.alertsListArray[0]?.alertCodeListModel[0], 'info')
      );
    }
  };

  const getMediaTourFromUXL = async (allid: any) => {
    /**
     * get all media by property id
     */
    try {
      const { data, error } = await getMedia({
        variables: {
          ids: allid,
          limitPerCategory: 2,
        },
        context: {
          headers: {
            'x-b3-traceId': searchQueryData?.sessionToken ?? 'fallback-token',
            'x-b3-spanId': requestID !== '' ? requestID : `${Date.now()}`,
            'x-request-id': requestID !== '' ? requestID : `${Date.now()}`,
            'accept-language': currentLocale,
          },
        },
      });
      if (data) {
        setSearchResult({
          type: SearchActions.updateMedia,
          payload: {
            media: data.propertiesByIds,
          },
        });
      }
      if (error) {
        Axios.post(loggerApiURL, {
          message: `error with media UXL api for sessionId ${sessionID}: ${JSON.stringify(error)}`,
        });
      }
    } catch (e) {
      Axios.post(loggerApiURL, {
        message: `error with media UXL api for sessionId ${sessionID}: ${JSON.stringify(e)}`,
      });
    }
  };

  const loadCurrencyOnceResultLoaded = async (data: any) => {
    /**
     * load all price currency once we get the result
     */
    let currencyListArr: Array<string> | undefined;
    data?.forEach((edge: any) => {
      const ratesNode = !isDTT
        ? dttRatesTransformer(
            JSON.parse(JSON.stringify(edge?.node?.rates ?? [])) ??
              JSON.parse(JSON.stringify(edge?.node?.property?.rates ?? []))
          )
        : edge?.node?.rates;
      /**fetch rates nodes accroding to api */
      if (ratesNode && Object.keys(ratesNode).length > 0) {
        /**
         * filter rate node as per the usage
         */
        const currRateNode = getCurrentPriceRateBlock(searchQueryState, ratesNode);
        const currRate = getCurrRateAmountBlock(currRateNode);
        const currencyInfo = currRate?.amount;
        if (currencyInfo && currencyInfo.currency) {
          /**
           * store different currency info in a local var
           */
          if (currencyListArr && currencyListArr.indexOf(currencyInfo?.currency) === -1) {
            /**
             * set another currency if we have
             */
            currencyListArr.push(currencyInfo?.currency);
            return; // empty return statement to break further execution
          }
          if (currencyListArr === undefined) {
            /**
             * set first currency
             */
            currencyListArr = [currencyInfo?.currency];
            return; // empty return statement to break further execution
          }
        }
      }
    });
    setSearchQuery({
      type: SearchActions.updateCurrency,
      payload: {
        currentOriginCurrency: currencyListArr,
      },
    });
    if (
      (isInitialLoad && searchQueryState.currentCurrency !== DefaultValue) ||
      (searchQueryState.currentCurrency !== DefaultValue &&
        searchQueryState.currentCurrency === searchQueryState.currentAppliedCurrency &&
        fetchCurrencyConversionFactors)
    ) {
      /**
       * if we have diffrent currency on search load
       */
      !skipQuery && (await getDataWithCurrencyFilterApplied(currencyListArr));
      return; // empty return statement to break further execution
    }
    return; // empty return statement to break further execution
  };

  const errorHandler = async (errorHandlerPayload: {
    _res: any;
    incorrectDestinationErrorCode: any;
    filtersHidden: any;
    paginationHidden: any;
    incorrectDestinationWarningCode: any;
    totalFilterCount: any;
    incorrectDestinationWarningBlock: any;
  }) => {
    const {
      _res,
      incorrectDestinationErrorCode,
      filtersHidden,
      paginationHidden,
      incorrectDestinationWarningCode,
      totalFilterCount,
      incorrectDestinationWarningBlock,
    } = errorHandlerPayload;
    if (
      (_res?.status?.[0]?.errors?.[0]?.code &&
        !propertyCardHiddenCodes?.includes(incorrectDestinationErrorCode) &&
        (filtersHidden || paginationHidden)) ||
      propertyCardHiddenCodes?.includes(incorrectDestinationWarningCode)
    ) {
      filtersHidden?.classList.add('filters-container-hidden');
      paginationHidden?.classList.add('filters-container-hidden');
      //flag to to detect error
      setErrorScenario(true);
    }

    // Keeping both warnings and errors in the condition to ensure that both are displayed
    if (_res?.status?.[0]?.errors?.[0]?.code || _res?.status?.[0]?.warnings?.[0]?.code) {
      /**
       * error cases if we get result 0
       */
      if (totalFilterCount && !_res?.total) {
        setIsLoadingSearchResult(false);
        setSearchResultAlerts(
          getAlertsData(
            jsonContent?.alertsListArray?.filter(
              // eslint-disable-next-line @typescript-eslint/no-explicit-any
              (key: any) => key.alertMsgTypeName === clearAllFilterKey
            )[0]?.alertCodeListModel[0],
            'warning'
          )
        );
        setWasMapViewEnabled(isMapViewEnabled);
        setISMapViewEnabled(false);
        sessionStorage.setItem('map_view', 'false');
      } else {
        Axios.post(loggerApiURL, {
          message: `SearchResults component totalFilterCount and _res?.total for sessionId ${sessionID}: ${totalFilterCount}, ${_res?.total}`,
        });
        //errors will be shown based on the respective conditions which satisfies
        if (completeSession?.data?.AriesSearch?.searchCriteria?.searchType === 'NearAddress') {
          //To update error key in session doc
          await updateSessionDocErrorMessages(sessionID, SESSION_APP_GET_CALL_URL, SESSION_GET_CALL_URL_CLIENT, [
            'search-error-messages|search.form.near.address.property.result.not.found',
          ]);
          //to set the error message
          setSearchResultAlerts(
            getAlertsData(
              jsonContent?.alertsListArray?.filter(
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                (key: any) => key.alertMsgTypeName === noNearAddressKey
              )[0]?.alertCodeListModel[0],
              'search.form.near.address.property.result.not.found'
            )
          );
        } else {
          const errorBlockLength = _res?.status?.[0]?.errors ? _res?.status?.[0]?.errors.length : 0;
          const warningBlockLength = _res?.status?.[0]?.warnings ? _res?.status?.[0]?.warnings.length : 0;
          for (let errorBlockIterator = 0; errorBlockIterator < errorBlockLength; errorBlockIterator++) {
            const errorBlock = _res?.status?.[0]?.errors?.[errorBlockIterator];
            if (!validErrorCodes?.includes(errorBlock?.code)) {
              continue;
            }
            switch (errorBlock?.code ?? '') {
              case 'LAR-1001':
                //To update error key in session doc
                await updateSessionDocErrorMessages(sessionID, SESSION_APP_GET_CALL_URL, SESSION_GET_CALL_URL_CLIENT, [
                  'search-error-messages|no.hotels.within.radius.error.msg',
                ]);
                //to set the error message
                setSearchResultAlerts(
                  getAlertsData(
                    jsonContent?.alertsListArray?.filter(
                      // eslint-disable-next-line @typescript-eslint/no-explicit-any
                      (key: any) => key.alertMsgTypeName === noHotelsWithinRadiusKey
                    )?.[0]?.alertCodeListModel[0],
                    'no.hotels.within.radius.error.msg'
                  )
                );
                break;
              case 'LAR-1002':
                //To update error key in session doc
                await updateSessionDocErrorMessages(sessionID, SESSION_APP_GET_CALL_URL, SESSION_GET_CALL_URL_CLIENT, [
                  'search-error-messages|no.availability.within.radius.error.msg',
                ]);
                //to set the error message
                setSearchResultAlerts(
                  getAlertsData(
                    jsonContent?.alertsListArray?.filter(
                      // eslint-disable-next-line @typescript-eslint/no-explicit-any
                      (key: any) => key.alertMsgTypeName === noAvailabilityKey
                    )[0]?.alertCodeListModel[0],
                    'no.availability.within.radius.error.msg'
                  )
                );
                break;
              case 'LAR-1003':
                //To update error key in session doc
                await updateSessionDocErrorMessages(sessionID, SESSION_APP_GET_CALL_URL, SESSION_GET_CALL_URL_CLIENT, [
                  'search-error-messages|property.search.hotels.maxcapacity.not.available',
                ]);
                //to set the error message
                setSearchResultAlerts(
                  getAlertsData(
                    jsonContent?.alertsListArray?.filter(
                      // eslint-disable-next-line @typescript-eslint/no-explicit-any
                      (key: any) => key.alertMsgTypeName === maxCapacityKey
                    )[0]?.alertCodeListModel[0],
                    'property.search.hotels.maxcapacity.not.available'
                  )
                );
                break;
              // Displays default error message if new error code is detected. Not passing data object to ensure if condition passes
              default:
                if (_res?.status?.[0]?.errors?.[0]?.code) {
                  displayDefaultError(_res?.status?.[0]?.errors?.[0]?.code);
                }
            }
          }
          if (incorrectDestinationWarningBlock) {
            //To update error key in session doc
            await updateSessionDocErrorMessages(sessionID, SESSION_APP_GET_CALL_URL, SESSION_GET_CALL_URL_CLIENT, [
              'search-error-messages|no.hotels.within.radius.error.msg',
            ]);
            //to set the error message
            setSearchResultAlerts(
              getAlertsData(
                jsonContent?.alertsListArray?.filter(
                  // eslint-disable-next-line @typescript-eslint/no-explicit-any
                  (key: any) => key.alertMsgTypeName === noHotelsWithinRadiusKey
                )?.[0]?.alertCodeListModel[0],
                'no.hotels.within.radius.error.msg'
              )
            );
            //flag to to detect error
            setErrorScenario(true);
          } else {
            let sessionCode = '';
            let aemFilterKey = '';
            let alertCode = '';
            let alertPriority = 100;
            let isErrorScenario = false;
            let endUserAlertMessage = '';
            for (let warningBlockIterator = 0; warningBlockIterator < warningBlockLength; warningBlockIterator++) {
              const warningBlock = _res?.status?.[0]?.warnings?.[warningBlockIterator];
              if (!validWarningCodes?.includes(warningBlock?.code)) {
                continue;
              }
              let currentPriority = 101;
              // to call warning scenarios based on UXL response
              switch (warningBlock?.code ?? '') {
                // letting the LAR-1002 case fall through since we do not get results from UXL in BAU and hence, filters must be hidden.
                // In DTT UXL, we get results so the if condition is not required.
                case 'LAR-1002':
                case 'AMP181':
                case 'WARN-RATES-1000':
                  if (warningBlock?.code.includes('AMP')) {
                    currentPriority = AMPAlertPriority;
                  } else {
                    currentPriority = SERPAlertPriority;
                  }
                  if (currentPriority < alertPriority) {
                    alertPriority = currentPriority;
                    sessionCode = 'search-error-messages|no.availability.within.radius.error.msg';
                    aemFilterKey = noAvailabilityKey;
                    alertCode =
                      warningBlock?.code === 'AMP181' || warningBlock?.code === 'WARN-RATES-1000'
                        ? warningBlock?.code
                        : 'no.availability.within.radius.error.msg';
                    endUserAlertMessage =
                      warningBlock?.code === 'AMP181' || warningBlock?.code === 'WARN-RATES-1000'
                        ? warningBlock?.message
                        : '';
                    isErrorScenario = true;
                  }
                  break;
                case 'queries.v2.properties.limit.range.dev.2':
                  currentPriority = SERPAlertPriority;
                  if (currentPriority < alertPriority) {
                    alertPriority = currentPriority;
                    sessionCode = '';
                    aemFilterKey = tooManyPropertiesErrorKey;
                    alertCode = 'queries.v2.properties.limit.range.dev.2';
                    endUserAlertMessage = '';
                    isErrorScenario = false;
                  }
                  break;
                case 'WARN-RATES-1001':
                  currentPriority = SERPAlertPriority;
                  if (currentPriority < alertPriority) {
                    alertPriority = currentPriority;
                    sessionCode = '';
                    aemFilterKey = noAvailabilityKey;
                    alertCode =
                      warningBlock?.code === 'WARN-RATES-1001'
                        ? warningBlock?.code
                        : 'queries.v2.properties.limit.range.dev.2';
                    endUserAlertMessage = warningBlock?.code === 'WARN-RATES-1001' ? warningBlock?.message : '';
                    isErrorScenario = false;
                  }
                  break;
                case 'WARN-SEARCH-1002':
                  currentPriority = SERPAlertPriority;
                  if (currentPriority < alertPriority) {
                    alertPriority = currentPriority;
                    sessionCode = 'search-error-messages|no.hotels.within.radius.error.msg';
                    aemFilterKey = noHotelsWithinRadiusKey;
                    alertCode =
                      warningBlock?.code === 'WARN-SEARCH-1002'
                        ? warningBlock?.code
                        : 'no.hotels.within.radius.error.msg';
                    endUserAlertMessage = warningBlock?.code === 'WARN-SEARCH-1002' ? warningBlock?.message : '';
                    isErrorScenario = true;
                  }
                  // to add hidden class to filter and pagination
                  filtersHidden?.classList.add('filters-container-hidden');
                  paginationHidden?.classList.add('filters-container-hidden');
                  break;
                default:
                  break;
              }
            }
            if (alertPriority < 100) {
              if (sessionCode !== '') {
                //To update error key in session doc
                await updateSessionDocErrorMessages(sessionID, SESSION_APP_GET_CALL_URL, SESSION_GET_CALL_URL_CLIENT, [
                  sessionCode,
                ]);
              }
              if (isErrorScenario) {
                //flag to to detect error
                setErrorScenario(true);
              }
              //to set the error message
              setSearchResultAlerts(
                getAlertsData(
                  ErrorFrameworkCodeArray.includes(alertCode)
                    ? {
                        alertLinkTextLabel: endUserAlertMessage.match(LinkMatchRegex)?.[1] || '',
                        alertMessageLabel: endUserAlertMessage.replace(LinkMatchRegex, '${AlertLinkTextLabel}'),
                      }
                    : jsonContent?.alertsListArray?.filter(
                        // eslint-disable-next-line @typescript-eslint/no-explicit-any
                        (key: any) => key.alertMsgTypeName === aemFilterKey
                      )[0]?.alertCodeListModel[0],
                  alertCode
                )
              );
            }
          }
        }
      }
    }
    if (_res?.total && isUnsuccessfulUserJourney()) {
      const alert = jsonContent?.alertsListArray?.filter(
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (key: any) => key.alertMsgTypeName === unsuccessfulSellKey
      )[0];
      setSearchResultAlerts(getAlertsData(alert?.alertCodeListModel[0], 'UnsuccessfulSell'));
    }
    setIsLoadingSearchResult(false);
  };

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const loadSearchResults = async (data: any): Promise<void> => {
    const sessionDataObject = sessionData?.data ? sessionData?.data : sessionData?.cacheData?.data;
    const flexibleDate = sessionDataObject?.AriesSearch?.searchCriteria?.availabilityRequestVO?.flexibleDate;
    const latitude = sessionDataObject?.AriesSearch?.searchCriteria?.address?.latitude;
    const destinationType = sessionDataObject?.AriesSearch?.searchCriteria?.address?.destinationType;
    //Can not remove these selectors, As these selectors are from different component.
    const filtersHidden = document.querySelector('.filter-component');
    const paginationHidden = document.querySelector('.pagination-sort-container');
    const _res = data;
    await loadCurrencyOnceResultLoaded(_res.edges); // load currency post search result
    // responseDataFromLoadSearchResults = data;
    const dataLayerObj = window.dataLayer ?? {};
    try {
      //removes the filters hidden class if no error shows up
      if (filtersHidden || paginationHidden) {
        filtersHidden?.classList.remove('filters-container-hidden');
        paginationHidden?.classList.remove('filters-container-hidden');
      }
      setErrorScenario(false);

      setIsStateOrCountry(
        searchQueryState && searchQueryState?.search?.latitude
          ? false
          : _res?.searchCenter === null || _res?.searchCenter?.latitude === null || !_res?.searchCenter
      );
      const totalFilterCount = getTotalFilterCount(searchQueryState);
      const sortByOptions =
        !isStateOrCountry && !isFlexibleDateSearch
          ? isSOOEnabled &&
            !determineExclusionCriteriaForSortOptions(latitude, destinationType, flexibleDate) &&
            isRecommendedSortSegmentId(segmentId)
            ? pointsChecked
              ? 'recommended,distance,city,points,brand'
              : 'recommended,distance,city,price,brand'
            : pointsChecked
            ? 'distance,city,points,brand'
            : 'distance,city,price,brand'
          : !isStateOrCountry && isFlexibleDateSearch
          ? isSOOEnabled &&
            !determineExclusionCriteriaForSortOptions(latitude, destinationType, flexibleDate) &&
            isRecommendedSortSegmentId(segmentId)
            ? 'recommended,distance,city,brand'
            : 'distance,city,brand'
          : isStateOrCountry && isFlexibleDateSearch
          ? 'city,brand'
          : pointsChecked
          ? 'city,points,brand'
          : 'city,price,brand';

      localStorage.setItem('sortByOptions', sortByOptions);
      updateDataLayerObj(
        dataLayerObj,
        _res,
        searchQueryState,
        isFlexibleDateSearch,
        isMapViewEnabled,
        datalayerProperties,
        isAutoSuggestSelectedSearch,
        isRecentViewSelectedSearch,
        sortByOptions,
        headersData?.referer,
        isDTT,
        searchQueryState?.includeUnavailableProperties
      );
      let localSearchCounterValue;
      if (sessionStorage.getItem('updateSearchCounter')) {
        const sessionValue = sessionStorage.getItem('updateSearchCounter');
        const maxValue = Math.max(parseInt(sessionValue as string), updateSearchCounter);
        setUpdateSearchCounter(maxValue + 1);
        sessionStorage.setItem('updateSearchCounter', (maxValue + 1).toString());
        localSearchCounterValue = (maxValue + 1).toString();
      } else {
        sessionStorage.setItem('updateSearchCounter', `${updateSearchCounter}`);
        localSearchCounterValue = updateSearchCounter;
      }
      dataLayerObj['updates_search_call_counter'] = localSearchCounterValue;
      // Update the window.location.hash with the update search counter
      window.history.replaceState({}, headersData?.referer as string, `#/${localSearchCounterValue}/`);
      setSearchResult({
        /**
         * set search result for the user query
         */
        type: SearchActions.setSearchResultData,
        payload: {
          pageInfo: _res?.pageInfo,
          total: _res?.total,
          edges: _res?.edges,
          searchCenter: _res?.searchCenter,
          facets: _res?.facets,
        },
      });
      setSearchQuery({
        /**set filter/facets for the search result */
        type: SearchActions.setFilter,
        payload: _res?.facets,
      });

      //filters and pagination are hidden if error shows
      const incorrectDestinationWarningBlock = _res?.status?.[0]?.warnings?.find(
        (warning: any) => warning.code === 'WARN-SEARCH-1006'
      );
      const incorrectDestinationErrorBlock = _res?.status?.[0]?.errors?.find((error: any) => error.code === 'LAR-1001');
      const incorrectDestinationWarningCode = incorrectDestinationWarningBlock?.code ?? '';
      const incorrectDestinationErrorCode = incorrectDestinationErrorBlock?.code ?? '';
      errorHandler({
        _res,
        incorrectDestinationErrorCode,
        filtersHidden,
        paginationHidden,
        incorrectDestinationWarningCode,
        totalFilterCount,
        incorrectDestinationWarningBlock,
      });
    } catch (e) {
      Axios.post(loggerApiURL, {
        message: `SearchResults component UXL catch error for sessionId ${sessionID}: ${inspect(e)}`,
      });
      setSearchResultAlerts(
        getAlertsData(jsonContent?.alertsListArray && jsonContent?.alertsListArray[0]?.alertCodeListModel[0], 'info')
      );
      //handle error at this place for any call
      setIsLoadingSearchResult(false);
    }
  };

  const renderedDataValue = useMemo(
    () => ({
      jsonContent,
      configData,
      isMapViewEnabled,
      setISMapViewEnabled,
      GOOGLE_MAP_API_KEY,
      recentlyViewed,
      setRecentlyViewed,
      featureSelected,
      setFeatureSelected,
      isFlexibleDateSearch,
      setIsFlexibleDateSearch,
      isSearchClicked,
      setIsSearchClicked,
      isStateOrCountry,
      setIsStateOrCountry,
      continueCtaProperty,
      setContinueCtaProperty,
      sessionObject,
      setSessionObject,
      revisionToken,
      setRevisionToken,
      savedProperties,
      setSavedProperties,
      isSpecialRateSearch,
      setIsSpecialRateSearch,
      formValues,
      setFormValues,
      isAutoSuggestSelectedSearch,
      setIsAutoSuggestSelectedSearch,
      isRecentViewSelectedSearch,
      setIsRecentViewSelectedSearch,
      isErrorState,
      setIsErrorState,
      isLastCardProcessed,
      setIsLastCardProcessed,
      imageURL,
      setImageURL,
      isTaxesandFeesIncludedFromPopup,
      setIsTaxesandFeesIncludedFromPopup,
    }),
    [
      jsonContent,
      configData,
      isMapViewEnabled,
      GOOGLE_MAP_API_KEY,
      recentlyViewed,
      featureSelected,
      isFlexibleDateSearch,
      isSearchClicked,
      isStateOrCountry,
      continueCtaProperty,
      sessionObject,
      revisionToken,
      savedProperties,
      isSpecialRateSearch,
      formValues,
      isAutoSuggestSelectedSearch,
      isRecentViewSelectedSearch,
      isErrorState,
      isLastCardProcessed,
      imageURL,
      isTaxesandFeesIncludedFromPopup,
    ]
  );

  useEffect(() => {
    setContinueCtaProperty(
      completeSession?.data
        ? completeSession?.data?.AriesReservation?.propertyId
        : completeSession?.cacheData?.data?.AriesReservation?.propertyId
    );
    setIsSpecialRateSearch(
      completeSession?.data?.AriesSearch?.searchCriteria?.availabilityRequestVO?.clusterCode !==
        SPECIAL_RATE_TYPE_NONE ||
        (formValues && formValues?.specialRates && formValues?.specialRates?.clusterCode !== SPECIAL_RATE_TYPE_NONE)
    );
    eventUtil.on('displayLoader', () => {
      setIsLoadingSearchResult(true);
      setSearchResult({
        /**
         * set search result empty
         */
        type: SearchActions.setSearchResultData,
        payload: {
          pageInfo: {},
          total: 0,
          edges: [],
        },
      });
    });
    setUpdatedDestinationType(
      completeSession?.data?.AriesSearch?.searchCriteria?.address?.destinationType ??
        completeSession?.cacheData?.data?.AriesSearch?.searchCriteria?.address?.destinationType
    );
    eventUtil.on('updateShopPageFormValues', data => {
      /**
       * on update search click event listen
       */
      setKeywordSearch(false);
      const {
        usePoints,
        searchObj,
        isFlexibleDateSearch,
        formValues,
        destinationHiddenData,
        isAutoSuggestSelected,
        isRecentSearchSelected,
        updatedSessionData,
      } = data;
      setLeisureRegionValue(destinationHiddenData?.region ?? '');
      setIsSpecialRateSearch(
        updatedSessionData?.data?.AriesSearch?.searchCriteria?.availabilityRequestVO?.clusterCode !==
          SPECIAL_RATE_TYPE_NONE ||
          (formValues && formValues?.specialRates && formValues?.specialRates?.clusterCode !== SPECIAL_RATE_TYPE_NONE)
      );
      if (updatedSessionData) {
        setSessionData(updatedSessionData);
        setSessionIdValue(updatedSessionData?.data?.sessionToken || updatedSessionData?.key);
        const sessionDataObject = updatedSessionData?.data?.AriesSearch?.searchCriteria
          ? updatedSessionData?.data?.AriesSearch?.searchCriteria
          : updatedSessionData?.cacheData?.data?.AriesSearch?.searchCriteria;
        Axios.post(loggerApiURL, {
          message: `SearchResults update session Data, Search Criteria ${sessionID}: ${inspect(
            sessionDataObject
          )}, ${inspect(sessionDataObject?.address)}`,
        });
      }
      setHiddenDestData(destinationHiddenData);
      isFlexibleDateSearchRef.current = pageState?.authorMode || isAuthorMode ? false : isFlexibleDateSearch;
      setIsFlexibleDateSearch(pageState?.authorMode || isAuthorMode ? false : isFlexibleDateSearch);
      setFormValues(formValues);
      setIsAutoSuggestSelectedSearch(isAutoSuggestSelected);
      setIsRecentViewSelectedSearch(isRecentSearchSelected);

      setIsSearchClicked(true);
      const { options, latitude, destination } = searchObj;
      const { startDate, endDate } = options;
      setIsStateOrCountry(latitude !== null || leisureRegionValue ? false : true);
      const searchCriteriaObj = updatedSessionData?.data?.AriesSearch?.searchCriteria
        ? updatedSessionData?.data?.AriesSearch?.searchCriteria
        : updatedSessionData?.cacheData?.data?.AriesSearch?.searchCriteria;
      setNumberOfNights(
        searchCriteriaObj?.availabilityRequestVO?.lengthOfStay ??
          Math.ceil(moment(formValues?.dates?.toDate)?.diff(formValues?.dates?.fromDate, 'days', true) ?? 0)
      );
      setPointsChecked(usePoints);
      setFeatureSelected(false);
      setIsErrorState(true);
      setIsLastCardProcessed(false);
      setDistance(parseFloat(destinationHiddenData?.radius ?? searchCriteriaObj?.searchRadius));

      if (usePoints) {
        //reset price filter if we have applied any
        setSearchQuery({ type: SearchActions.setApplyFilter, payload: { [SearchFacetsList.price]: {} } });
      } else {
        //reset price filter if we have applied any
        setSearchQuery({ type: SearchActions.setApplyFilter, payload: { [SearchFacetsList.points]: {} } });
      }

      if (
        destination &&
        !destinationHiddenData?.city &&
        (destinationHiddenData?.state?.split(',').length > 0 ||
          destinationHiddenData?.country?.split(',').length > 0 ||
          destinationHiddenData?.region?.split(',').length > 0)
      ) {
        setStateSearch(true);
      } else {
        setStateSearch(false);
        if (destinationHiddenData.state) {
          setSearchQuery({
            type: SearchActions.setApplyFilter,
            payload: {
              [SearchFacetsList.states]: {},
            },
          });
        } else {
          setSearchQuery({
            type: SearchActions.setApplyFilter,
            payload: {
              [SearchFacetsList.countries]: {},
            },
          });
        }
      }

      const currentDate = moment(); // current date
      const diffFromStartDate = Math.abs(moment.duration(currentDate.diff(startDate)).asDays() ?? 0);
      const diffFromEndDate = Math.abs(moment.duration(currentDate.diff(endDate)).asDays() ?? 0);
      // set availability checkbox true or false basis of search object
      const isIncludeUnAvailableProperties = diffFromStartDate > 6 || diffFromEndDate > 6 ? true : false;
      setUpdatedDestinationType(searchCriteriaObj?.address?.destinationType);
      // Update the taxes and fees in search options based on the session data response
      setSearchQuery({
        type: SearchActions.updateTaxesAndAvailability,
        payload: {
          [SearchFacetsConstants.includeTaxes]: searchCriteriaObj?.showFullPrice === 'true' ? true : false,
        },
      });

      // setSearchQuery({ type: SearchActions.updatePoints, payload: { [SearchFacetsConstants.points]: usePoints } });
      setSearchQuery({
        type: SearchActions.updateQueryAndOtherSearchQueryParam,
        payload: {
          // set availability checkbox true or false basis of search object
          [SearchFacetsConstants.unavailableProperties]: isIncludeUnAvailableProperties,
          [SearchFacetsConstants.offset]: 0,
          [SearchFacetsConstants.goToNextPage]: 0,
          [SearchFacetsConstants.sort]: {
            fields: fetchSortFields(
              searchCriteriaObj?.address?.latitude,
              searchCriteriaObj?.address?.destinationType,
              formValues?.dates?.flexible === 'true' || formValues?.dates?.flexible === true ? true : false
            ),
          },
          // change this to above line if these is any change
          [SearchFacetsConstants.points]: usePoints, //remove seperate statement and add these into single update function
          [SearchFacetsConstants.search]: searchObj,
          //comment below lines if you want to presist the currency filter
          currentCurrency: DefaultValue,
          currentOriginCurrency: [],
          currentAppliedCurrency: DefaultValue,
        },
      });
    });

    return (): void => {
      eventUtil.remove('displayLoader', () => {});
      eventUtil.remove('updateShopPageFormValues', () => {});
    };
  }, []);

  const setDataToContext = (data: any, error: any): void => {
    /******* set data/error to context  */
    /*** remove code duplication  */
    if (
      (error || !data || !data.total || data?.total === 0) &&
      !data?.status?.[0]?.errors?.[0]?.code &&
      !data?.status?.[0]?.warnings?.[0]?.code
    ) {
      Axios.post(loggerApiURL, {
        message: `SearchResults component setDataToContext error for sessionId ${sessionID}: ${inspect(error)}`,
      });
      displayDefaultError(error, data);
    }
    if (data) {
      setISFilterChange(false);
      loadSearchResults(data);
    }
  };
  const fetchSortFields = (latitude: number, destinationType: string, flexibleDate: boolean) => {
    // sort options for hotellist=marsha and boost brand combined scenario
    if (
      !determineExclusionCriteriaForSortOptions(latitude, destinationType, flexibleDate) &&
      isRecommendedSortSegmentId(segmentId)
    ) {
      if (window && window?.dataLayer) {
        window.dataLayer['search_list_setting_sort_order'] = RECOMMENDED_OPTION?.toLowerCase();
      }
      return [
        {
          field: RECOMMENDED_OPTION,
          direction: SearchSortFieldsDirection.desc,
        },
      ];
    } else if (enableHotelList() === true && enableBoostBrands() === true) {
      return [
        {
          field: 'BRAND',
          direction: SearchSortFieldsDirection.asc,
        },
      ];
    } else if (enableHotelList() === true) {
      return [
        {
          field: 'PROPERTY_NAME',
          direction: SearchSortFieldsDirection.asc,
        },
      ];
    } else if (latitude) {
      return [
        {
          field: 'DISTANCE',
          direction: SearchSortFieldsDirection.asc,
        },
      ];
    } else {
      return SearchSortFieldForDISTANCE?.map((fieldVal: any) => {
        return {
          field: fieldVal,
          direction: SearchSortFieldsDirection.asc,
        };
      });
    }
  };

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const ifLeisureRegionApplicable = (searchPayload: any) => {
    //logic to handle leisureRegions if navigated from homepage , or else regular destination flow will work

    //if state or country search and destination is availabe , remove destination
    if (
      isStateSearch &&
      searchPayload.search.destination &&
      searchPayload.search.destination !== completeSession?.data?.AriesSearch?.searchCriteria?.airportCode
    ) {
      if (isDTT || !isFlexibleDateSearchRef.current) {
        delete searchPayload.search.destination;
      } else {
        searchPayload.search.destination = '';
      }
    }

    //if region is available in sessiondata , add leisure region to payload
    if (leisureRegionValue !== '') {
      if (
        searchPayload &&
        searchPayload.search &&
        searchPayload.search.destination &&
        isFlexibleDateSearchRef.current
      ) {
        searchPayload.search.destination = '';
      }
    } else {
      //if not state or country search , and destination is available on state , assign it to payload
      if (searchQueryState?.search?.destination && !isStateSearch) {
        searchPayload.search.destination = searchQueryState?.search?.destination;
      }
    }

    // remove destination from search payload in case no destination given for hotellist deeplink
    let hasDestinationParam = false;
    if (typeof window !== 'undefined') {
      const params = new URLSearchParams(window.location.search);
      hasDestinationParam =
        params?.has('destinationAddress.destination') && params?.get('destinationAddress.destination') !== '';
    }

    if (enableHotelList() === true && !hasDestinationParam && searchPayload?.search?.destination) {
      delete searchPayload?.search?.destination;
    }
  };

  const loadSearchResultsData = async (
    response: {
      fusionSearchId: string | undefined;
      searchQueryId: string | undefined;
    },
    sessionIdValue: string,
    recipeID?: string,
    isSearchFallback?: boolean,
    searchFallbackType?: string
  ) => {
    // calling datalayer app after API success so that we can pass fusion ID that we recieve from UXL to datalayer
    await callDataLayerOnFeatureChanges(
      resolvedUrl,
      headersData,
      query,
      datalayerParams,
      sessionIdValue,
      response.fusionSearchId,
      response.searchQueryId,
      isDTT,
      currentLocale,
      searchDestinationTypeForDatalayer,
      recipeID,
      isSearchFallback,
      searchFallbackType
    );
    setDataToContext(response, null);
  };

  //Handle response from search result
  const handleResponse = async (
    res: {
      data: { searchLowestAvailableRatesByDestination: any; searchPropertiesByDestination: any; search: any };
      isSearchFallback: boolean;
      searchFallbackType: string;
    },
    isDesti: boolean,
    isFlexibleDateSearch: boolean,
    isStateSearch: boolean | undefined,
    sessionIdValue: string,
    isAirport?: boolean,
    sooModel?: string
  ) => {
    const response = isDTT
      ? extractDataFromDTTResponse(res.data.search, isDesti, isFlexibleDateSearch, isStateSearch, isAirport)
      : extractDataFromResponse(res.data, isDesti, isFlexibleDateSearch, isStateSearch);
    if (!suppressListUntilMapReady) {
      setHidePropertyList(false);
    }
    setInitialLoad(false);
    setSearchResultsState([RATES_DATA], {
      [RATES_DATA]: { [RATES_DATA]: response },
    });

    const recipeID = getRecipeId(sooModel, response?.recipeId, isFlexibleDateSearch);
    /*
                Dispatches the searchCenter address field so as to Update
                the destination field value with searchCenter address, if destination query triggers.
                */
    if (
      (res.data?.searchLowestAvailableRatesByDestination ||
        res.data?.searchPropertiesByDestination ||
        res.data?.search?.properties?.searchByDestination ||
        res.data?.search?.lowestAvailableRates?.searchByDestination) &&
      response?.searchCenter !== null
    ) {
      eventUtil.dispatch('SearchResultsData', response?.searchCenter);
    }
    const allIDs = getAllPropertyIDS(response.edges);
    if (allIDs?.length) {
      getMediaTourFromUXL(allIDs);
    }

    // updating fusionId if we are getting it from response that we will pass to datalayer
    setFusionSearchId(isDTT ? response.searchQueryId ?? '' : response.fusionSearchId ?? '');
    if (
      !isLocalDev &&
      !['zh-CN', 'zh-TW'].includes(currentLocale) &&
      !completeSession?.data?.AriesSearch?.searchCriteria?.destinationAddressPlaceId &&
      !completeSession?.data?.AriesSearch?.searchCriteria?.address?.destinationType &&
      completeSession?.data?.AriesSearch?.searchCriteria?.address?.destination
    ) {
      try {
        const geoCoderResponse = await geoCodeAddress(
          completeSession.data.AriesSearch.searchCriteria.address.destination
        );
        const destinationTypeValue = getSearchDestinationTypeAnalytics(geoCoderResponse?.types);
        setSearchDestinationTypeForSession(destinationTypeValue);
        searchDestinationTypeForDatalayer = destinationTypeValue;
      } catch (err) {
        Axios.post(loggerApiURL, {
          message: `SearchResults component geocoder.geocode call failed for destination ${
            completeSession.data.AriesSearch.searchCriteria.address.destination
          }: ${inspect(err)}`,
        });
      }
    }
    loadSearchResultsData(response, sessionIdValue, recipeID, res?.isSearchFallback, res?.searchFallbackType);
  };

  //Search Result Data call START
  const getSearchDataOnAnyUIChanges = async (): Promise<void> => {
    try {
      const searchVar = getSearchResultQuery(
        searchQueryState,
        isTaxesandFeesIncludedFromPopup,
        showFullPriceInSession,
        isFlexibleDateSearch,
        custNumber.current,
        distance,
        currentLocale,
        isSOOEnabled,
        isDTT,
        sooOptions
      );

      let searchPayload = Object.assign({}, searchVar);
      const isDesti =
        searchVar.search.destination !== undefined &&
        searchVar.search.destination !== null &&
        searchVar.search.destination !== '';
      setIsDestinationSearch(isDesti);
      if (isInitialLoad && !suppressListUntilMapReady) {
        setHidePropertyList(false);
      }
      if (isDesti && isStateSearch) {
        searchPayload = getShopQueryForSearchInput(
          searchVar,
          hiddenDestData,
          searchQueryState,
          isFlexibleDateSearch,
          currentLocale,
          isSOOEnabled,
          isDTT,
          sooOptions
        );
      }
      ifLeisureRegionApplicable(searchPayload);
      let isAirport = false;
      if (
        searchPayload?.search?.destination?.toLowerCase() ===
        completeSession?.data?.AriesSearch?.searchCriteria?.airportCode?.toLowerCase()
      ) {
        isAirport = true;
      }
      const payload = {
        variables: {
          ...searchPayload,
        },
        ...queryCommonContext,
      };

      /****
       * create graphql call flexible/dated */
      if (isFlexibleDateSearch) {
        const UXLqueryPayloadData = {
          resolvedUrl,
          headersData,
          query,
          datalayerParams,
          sessionIdValue,
          currentLocale,
          apolloClientRef,
          setSearchResultsState,
          isDTT,
          params: payload,
          queryCallback: 'getFlexiblePropertyInfo',
          isFlexibleDateSearch,
          isDestinationSearch: isDesti,
          isStateSearch,
          isAirport,
        };
        executeUXLQueries(UXLqueryPayloadData).then(
          (res: any) => {
            if (res) {
              handleResponse(res, isDesti, isFlexibleDateSearch, isStateSearch, sessionIdValue, isAirport, sooModel);
            }
          },
          (error: any) => {
            if (error) {
              setDataToContext(null, error);
              if (isServerError(SEARCH_FALLBACK_SERVER_ERRORS, Number(error?.networkError?.statusCode))) {
                callDataLayerForSearchFallback(
                  resolvedUrl,
                  headersData,
                  query,
                  datalayerParams,
                  sessionIdValue,
                  isDTT,
                  currentLocale,
                  false,
                  UXL_COMPLETE_FAIL
                );
              }
              updatePageContextVar('resultsRetried', false);
              Axios.post(loggerApiURL, {
                message: `error with media UXL api for sessionId ${sessionID}: ${JSON.stringify(error)}`,
              });
            }
          }
        );
      } else {
        const UXLqueryPayloadData = {
          resolvedUrl,
          headersData,
          query,
          datalayerParams,
          sessionIdValue,
          currentLocale,
          apolloClientRef,
          setSearchResultsState,
          isDTT,
          params: payload,
          queryCallback: 'getDatedPropertyInfo',
          isFlexibleDateSearch,
          isDestinationSearch: isDesti,
          isStateSearch,
          isAirport,
        };
        executeUXLQueries(UXLqueryPayloadData).then(
          (res: any) => {
            if (res) {
              handleResponse(res, isDesti, isFlexibleDateSearch, isStateSearch, sessionIdValue, undefined, sooModel);
            }
          },
          (error: any) => {
            if (error) {
              setDataToContext(null, error);
              if (isServerError(SEARCH_FALLBACK_SERVER_ERRORS, Number(error?.networkError?.statusCode))) {
                callDataLayerForSearchFallback(
                  resolvedUrl,
                  headersData,
                  query,
                  datalayerParams,
                  sessionIdValue,
                  isDTT,
                  currentLocale,
                  false,
                  UXL_COMPLETE_FAIL
                );
              }
              updatePageContextVar('resultsRetried', false);
              Axios.post(loggerApiURL, {
                message: `error with media UXL api for sessionId ${sessionID}: ${JSON.stringify(error)}`,
              });
            }
          }
        );
      }
      eventUtil.dispatch('loadSearchForm', true);
    } catch (e) {
      Axios.post(loggerApiURL, {
        message: `SearchResults component getSearchDataOnAnyUIChanges catch block error for sessionId ${sessionID}: ${inspect(
          e
        )}`,
      });
      displayDefaultError(e);
    }
  };

  //Keyword Search Result Data call START
  const getKeywordSearchDataOnAnyUIChanges = async () => {
    try {
      if (!suppressListUntilMapReady) {
        setHidePropertyList(false);
      }
      const searchVar = getSearchResultQuery(
        searchQueryState,
        isTaxesandFeesIncludedFromPopup,
        showFullPriceInSession,
        isFlexibleDateSearch,
        custNumber.current,
        distance,
        currentLocale,
        isSOOEnabled,
        isDTT,
        sooOptions
      );
      const searchQuery = {
        limit: 40,
        offset: 0,
        search: {
          keyword: completeSession?.data?.AriesSearch?.searchCriteria?.keywordSearchRequestVO?.keywords,
          options: {
            ...searchVar?.search?.options,
            startDate: `${
              currentLocale === hardCodedAllLocale.ar
                ? convertArabicToEnglishNumbers(moment().format('YYYY-MM-DD'))
                : currentLocale === hardCodedAllLocale.hi
                ? convertHindiToEnglishNumbers(moment().format('YYYY-MM-DD'))
                : moment().format('YYYY-MM-DD')
            }`,
            endDate: `${
              currentLocale === hardCodedAllLocale.ar
                ? convertArabicToEnglishNumbers(moment().add(1, 'days').format('YYYY-MM-DD'))
                : currentLocale === hardCodedAllLocale.hi
                ? convertHindiToEnglishNumbers(moment().add(1, 'days').format('YYYY-MM-DD'))
                : moment().add(1, 'days').format('YYYY-MM-DD')
            }`,
          },
        },
      };
      const UXLqueryPayloadData = {
        resolvedUrl,
        headersData,
        query,
        datalayerParams,
        sessionIdValue,
        currentLocale,
        apolloClientRef,
        setSearchResultsState,
        isDTT,
        params: {
          variables: {
            ...searchQuery,
          },
          ...queryCommonContext,
        },
        queryCallback: 'getKeywordPropertyInfo',
      };
      const { data, error } = await executeUXLQueries(UXLqueryPayloadData);
      if (data) {
        setDataToContext(data.searchLowestAvailableRatesByKeyword, error);
        const allIDs = getAllPropertyIDS(data.searchLowestAvailableRatesByKeyword?.edges);
        if (allIDs?.length) {
          getMediaTourFromUXL(allIDs);
        }
        if (!isDTT && data?.searchLowestAvailableRatesByKeyword?.fusionSearchId) {
          // updating fusionId if we are getting it from response that we will pass to datalayer
          setFusionSearchId(data?.searchLowestAvailableRatesByKeyword?.fusionSearchId);
        }
      }
      if (error) {
        if (isServerError(SEARCH_FALLBACK_SERVER_ERRORS, Number(error?.networkError?.statusCode))) {
          callDataLayerForSearchFallback(
            resolvedUrl,
            headersData,
            query,
            datalayerParams,
            sessionIdValue,
            isDTT,
            currentLocale,
            false,
            UXL_COMPLETE_FAIL
          );
        }
        Axios.post(loggerApiURL, {
          message: `SearchResults component getKeywordSearchDataOnAnyUIChanges error for sessionId ${sessionID}: ${inspect(
            error
          )}`,
        });
        updatePageContextVar('resultsRetried', false);
        displayDefaultError(error, data?.searchLowestAvailableRatesByKeyword);
      }
    } catch (e) {
      updatePageContextVar('resultsRetried', false);
      Axios.post(loggerApiURL, {
        message: `SearchResults component getKeywordSearchDataOnAnyUIChanges catch block error for sessionId ${sessionID}: ${inspect(
          e
        )}`,
      });
      displayDefaultError(e);
    }
  };
  const getCurrencyData = async (currency: string) => {
    if (currency === searchQueryState.currentCurrency) {
      return {
        currentConversionRate: 1,
        currentConversionRateDecimalPoint: 1,
        currency: currency,
      };
    }

    const payloadObj = {
      input: {
        inputCurrencyISOCode: currency, // currency we have on property card
        outputCurrencyISOCode: searchQueryState?.currentCurrency?.toUpperCase(), //currency selected by user
        date: getESTDate(), //todays date
      },
    };

    const { data } = await getCurrencyConversionRate({
      variables: payloadObj,
      ...queryCommonContext,
    });

    if (data?.exchangeRateByCurrencyCodes?.outputCurrencyExchangeRate) {
      // This is a custom flag that we will pass to update session helper function
      // Based on this update session function will make datalayer call
      // we are setting this flag for interaction that are not calling LAR query in this case update currency
      setViewChangeButtonClicked(true);
    }

    return {
      currentConversionRate:
        data?.exchangeRateByCurrencyCodes?.outputCurrencyExchangeRate /
        Math.pow(10, data?.exchangeRateByCurrencyCodes?.outputCurrencyDecimalPoint),
      currentConversionRateDecimalPoint: data?.exchangeRateByCurrencyCodes?.outputCurrencyDecimalPoint,
      currency: currency,
    };
  };
  const getDataWithCurrencyFilterApplied = async (currencyArr?: Array<string> | undefined) => {
    const currencyList = currencyArr ?? searchQueryState.currentOriginCurrency;
    if (currencyList) {
      try {
        const data = await Promise.all(currencyList.map(getCurrencyData));
        setSearchQuery({
          /**
           * update currency conversion rate based on the currency selected
           */
          type: SearchActions.updateCurrency,
          payload: {
            currentConversionRate: data,
            currentAppliedCurrency: searchQueryState.currentCurrency, // set user current currency
          },
        });
        if (isFilterChange) {
          // call query function also if user has changed the filter with currency
          if (keywordSearch) {
            getKeywordSearchDataOnAnyUIChanges();
          } else {
            getSearchDataOnAnyUIChanges();
          }
        } else {
          if (!isInitialLoad) {
            if (sessionStorage.getItem('updateSearchCounter')) {
              const maxValue = parseInt(sessionStorage.getItem('updateSearchCounter') as string);
              sessionStorage.setItem('updateSearchCounter', (maxValue + 1).toString());
            } else {
              sessionStorage.setItem('updateSearchCounter', '0');
            }
            const searchCounterValue = sessionStorage.getItem('updateSearchCounter');
            if (window && window.dataLayer) {
              window.dataLayer['updates_search_call_counter'] = searchCounterValue;
            }
            // Update the window.location.hash with the update search counter
            window.history.replaceState({}, headersData?.referer, `#/${searchCounterValue}/`);
          }
          if (!suppressListUntilMapReady) {
            setHidePropertyList(false); // display property records
          }
          setIsLoadingSearchResult(false); // hide loader
        }
        updateDataLayerObj(
          window?.dataLayer ?? {},
          data,
          searchQueryState,
          isFlexibleDateSearch,
          isMapViewEnabled,
          datalayerProperties,
          isAutoSuggestSelectedSearch,
          isRecentViewSelectedSearch,
          localStorage.getItem('sortByOptions'),
          headersData?.referer,
          isDTT,
          searchQueryState?.includeUnavailableProperties
        );
        return; // stop next execution
      } catch (e) {
        log.debug(`currency:function error ${inspect(e)}`);
        Axios.post(loggerApiURL, {
          message: `SearchResults component getSearchDataOnAnyUIChanges catch block error for sessionId ${sessionID}: ${inspect(
            e
          )}`,
        });
        return; // stop next execution
      }
    }
    return; // stop next execution
  };

  const getUpdatedFilterOnUSelection = async (event: any) => {
    const payload = event?.detail;
    try {
      const params = new URLSearchParams(window.location.search);
      if (params.has('unsuccessfulSell')) {
        params.delete('unsuccessfulSell');
        const searchCounterValue = sessionStorage.getItem('updateSearchCounter');
        window.history.replaceState({}, headersData?.referer, decodeURIComponent(`?${params}#/${searchCounterValue}/`));
      }
      const searchVar = getSearchResultQuery(
        payload,
        isTaxesandFeesIncludedFromPopup,
        showFullPriceInSession,
        isFlexibleDateSearchRef.current,
        custNumber.current,
        distance,
        currentLocale,
        isSOOEnabled,
        isDTT,
        sooOptions
      );
      let searchPaylod = Object.assign({}, searchVar);
      const isDesti =
        searchVar.search.destination !== undefined &&
        searchVar.search.destination !== null &&
        searchVar.search.destination !== '';
      setIsDestinationSearch(isDesti);
      if (isDesti && isStateSearch) {
        searchPaylod = getShopQueryForSearchInput(
          searchVar,
          hiddenDestData,
          payload,
          isFlexibleDateSearchRef.current,
          currentLocale,
          isSOOEnabled,
          isDTT,
          sooOptions
        );
        if (isDTT) {
          delete searchPaylod.search.destination;
        } else if (isFlexibleDateSearchRef.current) {
          searchPaylod.search.destination = '';
        }
      }
      const load = {
        variables: {
          ...searchPaylod,
        },
        ...queryCommonContext,
      };
      /****
       * create graphql call flexible/dated */
      const { data, error } = isFlexibleDateSearchRef.current
        ? !skipQuery &&
          (await getFlexibleFilter(
            /***
             * flexible search api call
             */
            load,
            isDesti,
            isStateSearch
          ))
        : !skipQuery &&
          (await getDatedFilter(
            /***
             * dated search api call
             */
            load,
            isDesti,
            isStateSearch
          ));
      if (data) {
        let isAirport = false;
        if (
          searchPaylod?.search?.destination?.toLowerCase() ===
          completeSession?.data?.AriesSearch?.searchCriteria?.airportCode?.toLowerCase()
        ) {
          isAirport = true;
        }
        const res = isDTT
          ? extractDataFromDTTResponse(data.search, isDesti, isFlexibleDateSearchRef.current, isStateSearch, isAirport)
          : extractDataFromResponse(data, isDesti, isFlexibleDateSearchRef.current, isStateSearch);
        setFilterUpdateData(res);
      }
      if (error) {
        Axios.post(loggerApiURL, {
          message: `searchresult:error with UXL filter api for sessionId ${sessionID}: ${inspect(error)}`,
        });
      }
    } catch (e) {
      Axios.post(loggerApiURL, {
        message: `searchresult:error with UXL filter api for sessionId ${sessionID}: ${inspect(e)}`,
      });
    }
  };

  //need to remove this code once we are donw with client side calling pattern
  useEffect(() => {
    document.addEventListener('updateShopPageFilterModalValues', getUpdatedFilterOnUSelection); //removeEventListener is not working with eventUtil so using document.addEventListener
    eventUtil.on('observeFilterChangeToUpdateTheDataWithCurrency', () => {
      //listen to this event once currency will change with other filter
      setISFilterChange(true);
    });
    return (): void => {
      // remove all this event
      document.removeEventListener('updateShopPageFilterModalValues', getUpdatedFilterOnUSelection as any);
      eventUtil.remove('observeFilterChangeToUpdateTheDataWithCurrency', () => {});
    };
  }, [getUpdatedFilterOnUSelection]);

  useEffect(() => {
    if (!window.google || window.google === undefined) {
      appendMapFile();
    }
  }, []);
  //function to append google map script to the document with valid map api key before using google geocoder api.
  const appendMapFile = (): void => {
    const script = document.createElement('script');
    script.src = `https://maps.googleapis.com/maps/api/js?key=${google_map_api_key}&loading=async`;
    script.defer = true;

    document.head.appendChild(script);
  };

  /**
   * get and update latest session
   */
  const getLatestSessionData = async () => {
    const filters = getTotalFilterCount(searchQueryState);
    const lengthOfStayValue: number = nightsCount;

    const fieldsWithValuesTrue = fieldsInteractedInSERP(interactionsSelected);

    const appliedInteractions = interactionsAppliedOnSERP(
      searchQueryState,
      formValues,
      lengthOfStayValue,
      filters,
      featureSelected,
      isFlexibleDateSearch,
      searchResult
    );

    const updatedSessionDoc = await updateSessionDocProperties(
      sessionData?.key ??
        sessionData?.data?.sessionToken ??
        sessionData?.cacheData?.data?.sessionToken ??
        sessionData?.sessionToken,
      sessionObject?.accessToken,
      SESSION_APP_GET_CALL_URL,
      SESSION_GET_CALL_URL_CLIENT,
      datalayerParams,
      searchQueryState,
      savedProperties,
      appliedInteractions,
      resolvedUrl,
      headersData,
      query,
      fieldsWithValuesTrue,
      isMapViewEnabled,
      fusionSearchId,
      viewChangeButtonClicked,
      isDTT,
      currentLocale,
      searchDestinationTypeForSession
    );
    // Update the session data state value
    if (updatedSessionDoc && Object.keys(updatedSessionDoc).length > 0) {
      setSessionData(updatedSessionDoc);
      setSessionIdValue(updatedSessionDoc?.sessionToken);
    }
    setViewChangeButtonClicked(false);
    hqvDispatch({ type: HQV_ACTIONS.PROPERTY_SESSION_DATA, payload: updatedSessionDoc });
  };

  useEffect(() => {
    isMapViewEnabled && window?.scrollTo(0, 0); // scroll to top always when map view is enabled
    // currentAppliedCurrency contains the currency the results are currently in
    // currentCurrency contains the value that the user has newly selected
    // adding a condition to prevent redundant updateSession calls on currency change
    if (
      (searchQueryState?.currentAppliedCurrency === searchQueryState?.currentCurrency ||
        searchQueryState?.currentCurrency === DefaultValue) &&
      !isInitialLoad
    ) {
      getLatestSessionData();
    }
    setIsAutoSuggestSelectedSearch(false);
    setIsRecentViewSelectedSearch(false);
  }, [
    searchQueryState.search,
    searchQueryState[SearchFacetsConstants.goToNextPage],
    JSON.stringify(searchQueryState[SearchFacetsConstants.sort]),
    isMapViewEnabled,
    searchQueryState?.currentCurrency,
    searchQueryState?.currentConversionRate,
    searchQueryState?.includeTaxesAndFees,
  ]);

  const getSearchResultMockData = async () => {
    const response = await getMockSearchResultData();
    setSearchResult({
      /**
       * set search result for the user query
       */
      type: SearchActions.setSearchResultData,
      payload: {
        pageInfo: response?.pageInfo,
        total: response?.total,
        edges: response?.edges,
        // searchCenter: response?.searchCenter,
      },
    });
    //update search facets with mock data
    setSearchQuery({
      type: SearchActions.setFilter,
      payload: response?.facets,
    });
    //disable loading state because we are using mock data
    setIsLoadingSearchResult(false);
    if (!suppressListUntilMapReady) {
      setHidePropertyList(false);
    }
    eventUtil.dispatch('loadSearchForm', true);
  };

  const updateSearchAPICalls = () => {
    /**
     * fetch search result based on search query
     */
    setIsSearchClicked(false); // Reset search clicked flag after processing update search
    setHidePropertyList(true);
    setIsLoadingSearchResult(true);
    setSearchResultAlerts(SearchPageAlerts.default);
    window.scrollTo(0, 0);
    if (pageVal === 'chat' && AiSearchResults) {
      handleResponse(AiSearchResults.rawData, false, false, false, sessionIdValue);
    } else {
      if (!pageState?.authorMode && !isAuthorMode) {
        if (
          searchQueryState.currentCurrency === DefaultValue ||
          searchQueryState.currentCurrency === searchQueryState.currentAppliedCurrency ||
          isFlexibleDateSearch ||
          isInitialLoad
        ) {
          setSearchResult({
            /**
             * set search result empty
             */
            type: SearchActions.setSearchResultData,
            payload: {
              pageInfo: {},
              total: 0,
              edges: [],
            },
          });
          /**
           * get search result with two api call, basic info and media
           */

          if (keywordSearch) {
            !skipQuery && getKeywordSearchDataOnAnyUIChanges();
          } else {
            !skipQuery && getSearchDataOnAnyUIChanges();
          }
        } else {
          /**
           * get currency conversion rate on currency apply filter
           */
          !skipQuery && getDataWithCurrencyFilterApplied();
          // setSearchResultAlerts(SearchPageAlerts.success);
        }
      } else {
        // used in author mode

        getSearchResultMockData();
      }
    }
    setFetchCurrencyConversionFactors(false);
    setFilterUpdateData(null);
    if (isInitialSearchCall) {
      setIsInitialSearchCall(false);
    }
  };

  useEffect(() => {
    // update search on initial load
    if (
      isSOOEnabled &&
      currentLocale === hardCodedAllLocale.en &&
      !isFlexibleDate(
        sessionData?.data
          ? sessionData?.data?.AriesSearch?.searchCriteria?.availabilityRequestVO
          : sessionData?.cacheData?.data?.AriesSearch?.searchCriteria?.availabilityRequestVO
      )
    ) {
      callSegmentApi();
    } else {
      setTargetSegmentCallCompleted(true);
    }
  }, []);

  useEffect(() => {
    /**
     * main function to call every UXL api
     */
    if (!isInitialSearchCall) {
      if (
        isSearchClicked &&
        !targetSegmentCallCompleted &&
        isSOOEnabled &&
        currentLocale === hardCodedAllLocale.en &&
        !isFlexibleDate(
          sessionData?.data
            ? sessionData?.data?.AriesSearch?.searchCriteria?.availabilityRequestVO
            : sessionData?.cacheData?.data?.AriesSearch?.searchCriteria?.availabilityRequestVO
        )
      ) {
        callSegmentApi();
      } else {
        updateSearchAPICalls();
        if (sessionObject?.accessToken && !skipQuery) {
          fetchCustomerSavedProperties();
        }
      }
    }
  }, [
    searchQueryState.search,
    searchQueryState[SearchFacetsConstants.goToNextPage],
    JSON.stringify(searchQueryState[SearchFacetsConstants.sort]),
    searchQueryState.currentCurrency,
  ]);

  useEffect(() => {
    if (targetSegmentCallCompleted || pageVal === 'chat') {
      setTargetSegmentCallCompleted(false);
      updateSearchAPICalls();
      if (sessionObject?.accessToken && !skipQuery) {
        fetchCustomerSavedProperties();
      }
    }
  }, [targetSegmentCallCompleted, AiSearchResults]);

  /**
   * Function to take currency as input and generate the symbol for the same.
   * @returns fetches the saved properties of the users from uxl
   */

  const fetchCustomerSavedProperties = async () => {
    const { data } = await getCustomerToken({
      variables: {
        customerId: sessionObject?.consumerID,
      },
      context: {
        headers: {
          'x-request-id': requestID,
          Authorization: `${useClientEnvVarsStore.getState().envVarsObject['APOLLOGRAPHQL_AUTH_TOKEN']}, Bearer ${
            sessionObject?.accessToken
          }`,
        },
      },
    });
    const tempSavedArray: { id: any }[] = [];
    // eslint-disable-next-line array-callback-return
    data?.customer?.savedProperties?.map((item: { id: any }) => {
      tempSavedArray.push({ id: item.id });
    });
    setSavedProperties(tempSavedArray);
    dispatch({ type: 'populateState', payload: tempSavedArray });
  };

  //toggle map view
  const enableMapView = (mapViewClicked: boolean): void => {
    if (mapViewClicked) {
      // This is a custom flag that we will pass to update session helper function
      // Based on this update session function will make datalayer call
      // we are setting this flag for interaction that are not calling LAR query in this case map button click
      setViewChangeButtonClicked(true);
    }
    // Update the view type to map in URL
    const params = new URLSearchParams(window.location.search);
    params.set(searchFilters.view, 'map');
    window.history.replaceState({}, headersData?.referer, `${decodeURIComponent(`?${params}`)}${window.location.hash}`);
    const searchFormEl = document.getElementById('document_search_form_container_el_ref');
    // setSelectedHotel([]);
    sessionStorage.setItem('map_view', 'true');
    document.body.style.overflow = 'hidden';
    // Check if the current view is list view before changing it to map view
    if (!isMapViewEnabled) {
      if (window && window.scrollY && window.scrollY !== 0) {
        // If scrolled, return to unscrolled state so vh is calculated correctly. (Safari fix.)
        window.scrollTo(0, 0);
        // After scrolling is complete, enable map view.
        setTimeout(() => {
          setISMapViewEnabled(true);
          setInteractionsSelected({ ...interactionsSelected, listOrMapButton: true });
        }, 200);
      } else {
        // Else enable map view immediately.
        setISMapViewEnabled(true);
        setInteractionsSelected({ ...interactionsSelected, listOrMapButton: true });
      }
    }
    if (searchFormEl) {
      searchFormEl?.classList.add('map-view-sticky');
      // searchFormEl.style.top = `0px`; // AFAIK this isn't necessary. Leaving in case a regression shows up in testing.
      searchFormEl?.focus();
    }
    if (mapViewClicked) {
      if (sessionStorage.getItem('updateSearchCounter')) {
        const maxValue = parseInt(sessionStorage.getItem('updateSearchCounter') as string);
        sessionStorage.setItem('updateSearchCounter', (maxValue + 1).toString());
      } else {
        sessionStorage.setItem('updateSearchCounter', '0');
      }
      const searchCounterValue = sessionStorage.getItem('updateSearchCounter');
      if (window && window.dataLayer) {
        window.dataLayer['updates_search_call_counter'] = searchCounterValue;
      }
      // Update the window.location.hash with the update search counter
      window.history.replaceState({}, headersData?.referer, `#/${searchCounterValue}/`);
      if (window && window.dataLayer) {
        window.dataLayer['search_results_view'] = 'Map View';
      }
    }
  };

  //toggle list view
  const enableListView = (listViewClicked: boolean): void => {
    if (listViewClicked) {
      // This is a custom flag that we will pass to update session helper function
      // Based on this update session function will make datalayer call
      // we are setting this flag for interaction that are not calling LAR query in this case list button click
      setViewChangeButtonClicked(true);
    }
    // Update the view type to list in URL
    const params = new URLSearchParams(window.location.search);
    params.set(searchFilters.view, 'list');
    window.history.replaceState({}, headersData?.referer, `${decodeURIComponent(`?${params}`)}${window.location.hash}`);
    // Check if the current view is map view before changing it to list view
    if (isMapViewEnabled) {
      setISMapViewEnabled(false);
      setInteractionsSelected({ ...interactionsSelected, listOrMapButton: true });
    }
    sessionStorage.setItem('map_view', 'false');
    document.body.style.overflow = 'auto';
    // eventUtil.dispatch('makeSearchFormStickyForMapView', {isMapViewEnabled:false});
    const searchFormEl = document.getElementById('document_search_form_container_el_ref');
    if (searchFormEl) {
      searchFormEl.classList.remove('map-view-sticky');
    }
    if (listViewClicked) {
      if (sessionStorage.getItem('updateSearchCounter')) {
        const maxValue = parseInt(sessionStorage.getItem('updateSearchCounter') as string);
        sessionStorage.setItem('updateSearchCounter', (maxValue + 1).toString());
      } else {
        sessionStorage.setItem('updateSearchCounter', '0');
      }
      const searchCounterValue = sessionStorage.getItem('updateSearchCounter');
      if (window && window.dataLayer) {
        window.dataLayer['updates_search_call_counter'] = searchCounterValue;
      }
      // Update the window.location.hash with the update search counter
      // window.location.hash = `#/${searchCounterValue}/`;
      window.history.replaceState({}, headersData?.referer, `#/${searchCounterValue}/`);
      if (window && window.dataLayer) {
        window.dataLayer['search_results_view'] = 'List View';
      }
    }
  };

  useEffect(() => {
    /**
     * Show map or list view on the basis of session/URL params.
     * For initial load when view=map, keep the view as list until search results are fetched.
     */
    if (isLoadingSearchResult) {
      // While search results are loading, do not switch to map view even if session or URL says view=map.
      // We rely on the default list view state during this time.
      return;
    }

    const resultsViewType = completeSession?.data?.AriesSearch?.searchCriteria?.searchResultViewType
      ? completeSession?.data?.AriesSearch?.searchCriteria?.searchResultViewType
      : completeSession?.cacheData?.data?.AriesSearch?.searchCriteria?.searchResultViewType;
    const searchMapValue = sessionStorage?.getItem('map_view');

    // Prefer explicit URL param (view=map|list) over session values on initial load.
    const params = new URLSearchParams(window.location.search);
    const urlViewParam = params.get(searchFilters.view);
    let shouldShowMap: boolean | null = null;

    if (urlViewParam === 'map') {
      shouldShowMap = true;
    } else if (urlViewParam === 'list') {
      shouldShowMap = false;
    }

    if (shouldShowMap === null) {
      shouldShowMap = resultsViewType === 'map' || searchMapValue === 'true';
    }

    if (shouldShowMap && !errorScenario) {
      enableMapView(false);
      if (suppressListUntilMapReady) {
        setHidePropertyList(false);
        setSuppressListUntilMapReady(false);
      }
    } else {
      enableListView(false);
      if (suppressListUntilMapReady) {
        // We expected to prefer map view but could not (e.g. error scenario).
        // At this point, allow the list view to render.
        setHidePropertyList(false);
        setSuppressListUntilMapReady(false);
      }
    }

    const dataLayerObj = window.dataLayer ?? {};
    updateDataLayerObjSigin(dataLayerObj, datalayerProperties);
    if (window && window?.dataLayer) {
      window.dataLayer['search_list_setting_sort_order'] =
        (searchResult?.searchCenter?.latitude === null || searchResult?.searchCenter === null) &&
        (!searchQueryState?.search?.latitude || searchQueryState?.search?.latitude === null) &&
        searchQueryState[SearchFacetsConstants.sort]?.fields[1]?.field === 'CITY'
          ? searchQueryState[SearchFacetsConstants.sort]?.fields[1].field?.toLowerCase()
          : searchQueryState[SearchFacetsConstants.sort]?.fields[0].field?.toLowerCase();
    }
  }, [isLoadingSearchResult]);

  useEffect(() => {
    /**
     * Handler for resize event
     */
    if (window && window?.screen?.width && window?.dataLayer) {
      const screenSize = window?.screen?.width;
      if (screenSize < 992) {
        window.dataLayer['is_desktop'] = false;
      } else {
        window.dataLayer['is_desktop'] = true;
      }
    }
    const resizeHandler = (): void => {
      const currentViewIsMobile = CommonUtils.isOnlyMobileView();
      if (!isMobileState) {
        // viewport was not mobile earlier but now its mobile
        if (currentViewIsMobile) {
          setIsMobile(true);
        }
      } else {
        // viewport was mobile earlier but now its not
        if (!currentViewIsMobile) {
          setIsMobile(false);
        }
      }
    };
    window.addEventListener('resize', resizeHandler, { passive: true });
    return (): void => {
      window.removeEventListener('resize', resizeHandler);
    };
  }, [isMobileState]);

  const FilterProvideValue = useMemo(() => {
    /**
     * use memo hook to avoid assignment on every render
     */
    return { searchQueryState, setSearchQuery };
  }, [searchQueryState, setSearchQuery]);
  const SearchResultProviderValue = useMemo(() => {
    return { searchResult, setSearchResult };
  }, [searchResult, setSearchResult]);
  const SearchResultErrorProviderValue = useMemo(() => {
    return { searchResultAlerts, setSearchResultAlerts };
  }, [searchResultAlerts, setSearchResultAlerts]);

  // TODO: validate this need to wrap inside a function
  if (isMapViewEnabled && !searchResultAlerts.showPageAndFilter) {
    enableListView(false);
  }

  const setDefaultCurrency = (): void => {
    setSearchQuery({
      type: SearchActions.updateCurrency,
      payload: {
        currentCurrency: DefaultValue,
        currentAppliedCurrency: DefaultValue,
      },
    });
    setInteractionsSelected({ ...interactionsSelected, currencyConversion: true });
    // Update the currency filter to default in the URL
    updateQueryParams(
      {
        selectedCurrency: DefaultValue,
      },
      ['selectedCurrency'],
      headersData?.referer
    );
  };

  const resetAllFilter = (): void => {
    const payload = getSearchFilterClearState();
    setSearchQuery({ type: SearchActions.setApplyFilter, payload: payload });
    setSearchQuery({
      type: SearchActions.setQuery,
      payload: {
        [SearchFacetsConstants.facets]: {
          ...searchQueryState.search[SearchFacetsConstants.facets],
          ...getSearchAppliedFilter(payload, searchQueryState),
        },
      },
    });
    if (wasMapViewEnabled) {
      setISMapViewEnabled(true);
      sessionStorage.setItem('map_view', 'true');
      setWasMapViewEnabled(false);
    }
  };

  // Tooltip handling: CheckboxControlsList keeps assigning the hovered element to this ref.
  const tooltipAnchorRef = useRef<HTMLSpanElement | null>(null);
  // Store the latest payload + visibility flag; avoids rerendering lists on hover churn.
  const tooltipPendingContentRef = useRef<TooltipContentProps>({});
  const tooltipLayerRef = useRef<TooltipLayerHandle>(null);
  const tooltipVisibilityRef = useRef(false);

  // Checkbox controls push payloads here; the portal reads from the ref as soon as showToolTip flips true.
  const handleSetTooltipContent = useCallback((content: TooltipContentProps) => {
    tooltipPendingContentRef.current = content ?? {};
  }, []);

  const handleSetShowToolTip = useCallback(
    (value: React.SetStateAction<boolean>) => {
      const nextValue = typeof value === 'function' ? value(tooltipVisibilityRef.current) : value;
      tooltipVisibilityRef.current = nextValue;
      if (nextValue) {
        // When the checkbox toggles the tooltip on, the anchor ref might not be populated yet.
        // Retry with requestAnimationFrame so we always measure after the checkbox finishes its own updates.
        const content = tooltipPendingContentRef.current;
        const tooltipKey =
          content?.tooltipCode && tooltipAmenities[content.tooltipCode as keyof typeof tooltipAmenities]
            ? (tooltipAmenities[content.tooltipCode as keyof typeof tooltipAmenities] as string)
            : '';
        const tooltipText = content?.tooltipText ?? (tooltipKey ? jsonContent?.[tooltipKey] ?? '' : '');

        const tryShow = (attempt = 0) => {
          const anchor = tooltipAnchorRef.current;
          if (!anchor) {
            if (attempt < 4) {
              requestAnimationFrame(() => tryShow(attempt + 1));
            }
            return;
          }
          tooltipLayerRef.current?.showTooltip({
            heading: content?.tooltipHeading ?? '',
            text: tooltipText,
            anchor,
          });
        };

        tryShow();
      } else {
        tooltipLayerRef.current?.hideTooltip();
        tooltipAnchorRef.current = null;
      }
    },
    [jsonContent]
  );

  const showBannerConditionsInListView = (): boolean => {
    const result = !featureSelected && nightsCount >= 4 && pointsChecked && !isMapViewEnabled;
    return result;
  };

  const showMemberExclusiveBannerInListView = useMemo(
    () => showBannerConditionsInListView(),
    [featureSelected, nightsCount, pointsChecked, isMapViewEnabled]
  );

  const showBannerConditionsInMapView = (): boolean => {
    const result = !featureSelected && nightsCount >= 4 && pointsChecked && isMapViewEnabled;
    return result;
  };

  const showMemberExclusiveBannerInMapView = useMemo(
    () => showBannerConditionsInMapView(),
    [featureSelected, nightsCount, pointsChecked, isMapViewEnabled]
  );

  const isBackendUpdating = useRef<boolean>(false);
  const queue = useRef<any>([]);

  const consumeRevisionToken = () => {
    if (sessionData) {
      setRevisionToken(
        sessionData?.data
          ? sessionData?.data?.AriesCommon?.revisionToken
          : sessionData?.cacheData?.data?.AriesCommon?.revisionToken
      );
      if (isDTT) {
        custNumber.current = sessionData?.data
          ? sessionData?.data?.consumerID
          : sessionData?.cacheData?.data?.consumerID;
      } else {
        custNumber.current = sessionData?.data ? sessionData?.data?.rewardsId : sessionData?.cacheData?.data?.rewardsId;
      }
    }
  };

  const initialData = {
    // revisionToken: revisionToken,
    savedPropertiesList: savedProperties,
    triggerSaveProperties: false,
  };

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const savedPropertiesReducer = (dataList: typeof initialData, action: any) => {
    switch (action.type) {
      case 'added': {
        dataList.savedPropertiesList.push({ id: action.payload });
        return { ...dataList, triggerSaveProperties: true };
      }
      case 'removed': {
        dataList.savedPropertiesList = dataList.savedPropertiesList.filter((data: any) => data.id !== action.payload);
        return { ...dataList, triggerSaveProperties: true };
      }
      case 'populateState': {
        dataList.savedPropertiesList = action.payload;
        return { ...dataList, triggerSaveProperties: false };
      }
      case 'populateStateWithCallback': {
        dataList.savedPropertiesList = action.payload;
        return { ...dataList, triggerSaveProperties: true };
      }
      default: {
        return dataList;
      }
    }
  };

  const [savedData, dispatch] = useReducer(savedPropertiesReducer, initialData);

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const consumeSavedProperties = async (data: any) => {
    const savedPropertyData = data;
    if (savedPropertyData) {
      if (savedPropertyData?.updateCustomerSavedProperties?.status[0]?.httpStatus === 200) {
        setRevisionToken(savedPropertyData?.updateCustomerSavedProperties?.revisionToken);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const savedPropertiesArrayWithId: any = [];
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        savedPropertyData?.updateCustomerSavedProperties?.savedProperties?.map((idValue: any) =>
          savedPropertiesArrayWithId.push({ id: idValue.id })
        );
        setSavedProperties(savedPropertiesArrayWithId);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const marshaList: any = [];
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        savedPropertiesArrayWithId?.map((marsha: any) => marshaList.push(marsha?.id.toLowerCase()));

        isBackendUpdating.current = false;
        if (queue.current.length !== 0) {
          dispatch({ type: 'populateStateWithCallback', payload: savedPropertiesArrayWithId });
        } else {
          dispatch({ type: 'populateState', payload: savedPropertiesArrayWithId });
        }
      }
    } else if (isSavedDataStaleError) {
      setIsSavedDataStaleError(true);
    }
  };

  const checkStaleError = (data: DataUpdateProperties) => {
    if (data?.updateCustomerSavedProperties?.status[0]?.httpStatus === 412) {
      setIsSavedDataStaleError(true);
    }
  };

  //formation of update properties query
  const [updateProperties] = useMutation(phoenixShopUpdateCustomerSavedProperties, {
    onCompleted: data => {
      consumeSavedProperties(data);
      checkStaleError(data);
    },
    // notifyOnNetworkStatusChange: true, // did the work
    onError: error => {
      Axios.post(loggerApiURL, {
        message: `update property error for sessionId ${sessionID}: ${JSON.stringify(error)}`,
      });
    },
  });

  useEffect(() => {
    if (sessionObject?.consumerID && sessionObject?.accessToken && savedData.triggerSaveProperties) {
      //removing dulicate values from array which was causing the UXL call to break
      const uniqueSavedProperties = savedData?.savedPropertiesList?.filter((obj: { id: any }, index: number) => {
        return index === savedData?.savedPropertiesList?.findIndex((o: { id: any }) => obj.id === o.id);
      });
      if (!isBackendUpdating.current) {
        isBackendUpdating.current = true;

        const params = {
          input: {
            id: sessionObject?.consumerID,
            revisionToken: revisionToken,
            savedProperties: queue.current.length === 0 ? uniqueSavedProperties : queue.current.shift(),
          },
        };

        updateProperties({
          variables: {
            ...params,
          },
          context: {
            headers: {
              'x-request-id': requestID,
            },
          },
        });
      } else {
        queue.current.push(uniqueSavedProperties);
      }
    }
  }, [savedData]);

  useEffect(() => {
    eventUtil.on('changeZIndex', value => {
      if (document) {
        const filterEle = document.getElementsByClassName(
          'filters-container filters-map-view-container'
        ) as HTMLCollectionOf<HTMLElement>;
        const buttonEle = document.getElementsByClassName('drawer-icon-container') as HTMLCollectionOf<HTMLElement>;
        if (value && filterEle && buttonEle && filterEle.length) {
          filterEle[0]?.style.setProperty('z-index', '1');
          buttonEle[0]?.style.setProperty('z-index', '0', 'important');
        } else {
          filterEle[0]?.style.setProperty('z-index', '2');
          buttonEle[0]?.style.setProperty('z-index', '1');
        }
      }
    });
    return (): void => {
      eventUtil.remove('changeZIndex', () => {});
    };
  }, []);

  return (
    <renderedData.Provider value={renderedDataValue}>
      <SearchResultContext.Provider value={SearchResultProviderValue}>
        <SearchResultAlertContext.Provider value={SearchResultErrorProviderValue}>
          <SavedPropertiesDispatchContext.Provider value={{ savedData, dispatch }}>
            {/* show loader on click update search and return response upon successful UXL call */}
            {searchResultAlerts?.showPageAndFilter || isLoadingSearchResult ? (
              <SearchFilterContext.Provider value={FilterProvideValue}>
                <StyledSearchResultContainerDiv
                  className={clsx(
                    pageVal === 'chat' && !isMapViewEnabled ? 'p-3' : ' ',
                    pageVal !== 'chat' ? 'm-container-fullbleed ' : ' ',
                    isMapViewEnabled ? 'map-view ' : 'list-view alternate ',
                    !searchResultAlerts.showPageAndFilter ||
                      !searchResult.total ||
                      propertyCardHiddenAlertCodes.includes(searchResultAlerts?.code ?? '')
                      ? 'no-map-button'
                      : '',
                    segmentId ? segmentId : DEFAULT_SORT_OPTS
                  )}
                >
                  {/* Dedicated portal for tooltips so list items no longer need to render inline popovers. */}
                  <SearchResultsTooltipLayer ref={tooltipLayerRef} />
                  <>
                    <StyledFilterContainerDiv
                      className={
                        isMapViewEnabled ? 'filters-container filters-map-view-container' : 'filters-container'
                      }
                    >
                      <FiltersComponent
                        filterUpdateData={filterUpdateData}
                        isStateSearch={isStateSearch}
                        isDestinationSearch={isDestinationSearch}
                        className="filter-component"
                        setFetchCurrencyConversionFactors={setFetchCurrencyConversionFactors}
                        tooltipRefElement={tooltipAnchorRef}
                        setTooltipContent={handleSetTooltipContent}
                        modalRefElement={modalRefElement}
                        setShowToolTip={handleSetShowToolTip}
                        enableMapView={enableMapView}
                        enableListView={enableListView}
                      />
                      {showMemberExclusiveBannerInListView && (
                        <MemberExclusiveBanner numberOfNights={nightsCount} pointsChecked={pointsChecked} />
                      )}
                      {showMemberExclusiveBannerInMapView && !isLargeDesktop && (
                        <MemberExclusiveBanner numberOfNights={nightsCount} pointsChecked={pointsChecked} />
                      )}
                      {!isMapViewEnabled && !errorScenario && (
                        <PaginationSortByComponent
                          isMobileState={isMobileState}
                          className="pagination-sort-container search-results pb-md-2"
                          segmentId={segmentId}
                          isLatLongAvailable={isStateSearch}
                          setFetchCurrencyConversionFactors={setFetchCurrencyConversionFactors}
                          isCorpCodeEntered={isCorpCodeEntered}
                          destinationType={updatedDestinationType}
                        />
                      )}
                      {!isMapViewEnabled &&
                      searchResultAlerts?.errorMessage &&
                      searchResultAlerts?.showPageAndFilter &&
                      !isUnsuccessfulUserJourney() &&
                      searchResultAlerts?.type !== 'unsuccessfulSell' ? (
                        <AlertNotification
                          setLinkClick={
                            searchQueryState.currentCurrency === DefaultValue ? resetAllFilter : setDefaultCurrency
                          }
                          clickTrackingText={`Phoenix Search Results | ${
                            searchResultAlerts?.type === 'no-hotels'
                              ? 'Hotel Directory'
                              : 'Alert: Set default currency link clicked'
                          } | internal`}
                        />
                      ) : (
                        ''
                      )}
                      {!isMapViewEnabled &&
                      searchResultAlerts?.errorMessage &&
                      searchResultAlerts?.showPageAndFilter &&
                      isUnsuccessfulUserJourney() &&
                      searchResultAlerts?.type === 'unsuccessfulSell' ? (
                        <Messages
                          className="unsuccess-full-journey"
                          messageType="warning"
                          messageVariation={false}
                          messageHeading={searchResultAlerts?.heading}
                          messageText={searchResultAlerts?.errorMessage}
                          messageContentTabIndex={0}
                          messageRole="alert"
                        />
                      ) : (
                        ''
                      )}
                    </StyledFilterContainerDiv>
                    {hidePropertyList ? (
                      <SkeletonPropertyCardLoaderComponent
                        isViewportL={isDesktop}
                        isInitialLoad={isInitialLoad}
                        isMapViewEnabled={isMapViewEnabled}
                        segmentId={segmentId}
                        isLatLongAvailable={isStateSearch}
                      />
                    ) : (
                      <>
                        <div className="search-form-container">
                          <StyledSearchResultPropertyContainer
                            className={
                              isMapViewEnabled && pageVal !== 'chat'
                                ? clsx(
                                    'search-results-container',
                                    'color-scheme1',
                                    'search-map-view-result-container',
                                    isDrawerVisible ? 'active-drawer' : '',
                                    popPupOpen ? 'map-popup-position' : ''
                                  )
                                : clsx('search-results-container', isLoadingSearchResult ? 'hide-property-list' : '')
                            }
                          >
                            <PropertyListComponent
                              isMobileState={isMobileState}
                              memberExclusiveBannerDetails={{
                                featureSelected: featureSelected,
                                numberOfNights: nightsCount,
                                pointsChecked: pointsChecked,
                              }}
                              alertLinkClickFn={
                                searchQueryState.currentCurrency === DefaultValue ? resetAllFilter : setDefaultCurrency
                              }
                              handleStaleError={isSavedDataStaleError}
                              handlePopUpOpen={setPopupOpen}
                              enableListView={enableListView}
                              handleNextClick={handleNextClick}
                              isDrawerVisible={isDrawerVisible}
                              segmentId={segmentId}
                              isLatLongAvailable={isStateSearch}
                              setFetchCurrencyConversionFactors={setFetchCurrencyConversionFactors}
                              isCorpCodeEntered={isCorpCodeEntered}
                              onOpenHotelPanel={onOpenHotelPanel}
                            />
                          </StyledSearchResultPropertyContainer>
                          {isLoadingSearchResult && (
                            <SkeletonPropertyCardLoaderComponent
                              isViewportL={isDesktop}
                              isInitialLoad={isInitialLoad}
                              isMapViewEnabled={isMapViewEnabled}
                              segmentId={segmentId}
                              isLatLongAvailable={isStateSearch}
                            />
                          )}
                          {isMapViewEnabled && pageVal !== 'chat' && (
                            <button
                              type="button"
                              className={`drawer-icon-container color-scheme1 analytics-click custom_click_track ${
                                isDrawerVisible && 'active-drawer hide-drawer'
                              }`}
                              aria-label={jsonContent.propertyCardDrawerLabel}
                              onClick={(): void => setIsDrawerVisible(!isDrawerVisible)}
                              {...{
                                custom_click_track_value: `${clickTrackingLoc}| Property Card Drawer ${
                                  isDrawerVisible ? 'Opened' : 'Closed'
                                } |internal`,
                              }}
                              tabIndex={0}
                            >
                              <div className={`icon-arrow-${isDrawerVisible ? 'left' : 'right'} first`} />
                              <div className={`icon-arrow-${isDrawerVisible ? 'left' : 'right'} second`} />
                            </button>
                          )}
                        </div>
                        {!isDesktop && !isLargeDesktop && !isMapViewEnabled && (
                          <div className="map-button-container container fixed-button">
                            <button
                              className="map-button m-button-primary-inverse custom_click_track"
                              // custom_click_track_value={`${clickTrackingLoc}|  back to map view from list view |internal`}
                              {...{ custom_click_track_value: `QuickFilters| map | internal` }}
                              onClick={() => enableMapView(true)}
                            >
                              <span className="icon icon-map"></span> {jsonContent?.mapLabel}
                            </button>
                          </div>
                        )}
                      </>
                    )}
                  </>
                </StyledSearchResultContainerDiv>
              </SearchFilterContext.Provider>
            ) : (
              <StyledAlertNotificationDiv>
                <AlertNotification isNonPropertyList={true} isAloneOnPage={true} />
              </StyledAlertNotificationDiv>
            )}
          </SavedPropertiesDispatchContext.Provider>
        </SearchResultAlertContext.Provider>
      </SearchResultContext.Provider>
    </renderedData.Provider>
  );
};

export default SearchResultComp;
